import React, {
  useEffect,
  useState,
  useMemo,
  useRef,
  useCallback,
  useContext,
  createContext,
  memo,
  startTransition,
} from "react";
import { FaChevronDown } from "react-icons/fa";
import { Link, useNavigate, useLocation } from "react-router-dom";
import DashboardIcon from "../../Assests/Dashboard/dashboard.svg";
import ShoppingCartIcon from "../../Assests/Dashboard/orders.svg";
import SaleRegisterIcon from "../../Assests/Dashboard/sale_register.svg";
import CategoryIconActive from "../../Assests/Dashboard/category.svg";
import Inventory_Active_Icon from "../../Assests/Dashboard/Inventory_Active_Icon.svg";
import Inventory_Icon from "../../Assests/Dashboard/Inventory_Icon.svg";
import Employees_Active_Icon from "../../Assests/Dashboard/Employees_Active_Icon.svg";
import Employees_Icon from "../../Assests/Dashboard/Employees_Icon.svg";
import CouponIcon from "../../Assests/Dashboard/coupanb.svg";
import Tax_Active_Icon from "../../Assests/Dashboard/Tax_Active_Icon.svg";
import Tax_Icon from "../../Assests/Dashboard/Tax_Icon.svg";
import AttributesIcon from "../../Assests/Dashboard/attributesadmin.svg";
import PurchaseIcon from "../../Assests/Dashboard/purchesb.svg";
import Stock_take_Active_Icon from "../../Assests/Dashboard/Stock_take_Active_Icon.svg";
import Stock_take_Icon from "../../Assests/Dashboard/Stock_take_Icon.svg";
import ProductIcon from "../../Assests/Dashboard/productb.svg";
import dataIcon from "../../Assests/Dashboard/vender.svg";
import Customer_Active_icon from "../../Assests/Dashboard/Customer_Active_icon.svg";
import Customer_icon from "../../Assests/Dashboard/Customer_icon.svg";
import TimesheetsIcon from "../../Assests/Dashboard/timesheetb.svg";
import StoreSettingIcon from "../../Assests/Dashboard/store.svg";
import ReportIcon from "../../Assests/Dashboard/reporting.svg";
import DashIcon from "../../Assests/Dashboard/dashIcon.svg";
import OrderYellow from "../../Assests/Dashboard/ordery.svg";
import CatIcon from "../../Assests/Dashboard/categoryd.svg";
import AtriIcon from "../../Assests/Dashboard/attributesy.svg";
import ProdIcon from "../../Assests/Dashboard/productY.svg";
import VenIcon from "../../Assests/Dashboard/venderb.svg";
import Vendor_Active_icon from "../../Assests/Dashboard/Vendor_Active_icon.svg";
import Vendor_Icon from "../../Assests/Dashboard/Vendor_Icon.svg";
import VenIconActive from "../../Assests/Dashboard/vendery.svg";
import DataIconActive from "../../Assests/Dashboard/importy.svg";
import CouIcon from "../../Assests/Dashboard/coupony.svg";
import MixMatchIcon from "../../Assests/Dashboard/mix-match-icon.svg";
import MixMatchIcon1 from "../../Assests/Dashboard/mix-match-icon-1.svg";
import PurIcon from "../../Assests/Dashboard/purchaseY.svg";
import SettingIcon from "../../Assests/Dashboard/settingY.svg";
import ResportIcons from "../../Assests/Dashboard/reports.svg";
import timesheetblackIcon from "../../Assests/Dashboard/timesheetblackIcon.svg";
import Loyalty from "../../Assests/Taxes/Loyalty Program.svg";
import LoyaltIcon from "../../Assests/Taxes/loyaltyactive.svg";
import { useMediaQuery } from "@mui/material";
import {
  setMenuOpen,
  setIsDropdownOpen,
  setIsMobileViewActive,
  setIsOpenedByHover,
  setIsOpenedByIcon,
  pinSidebar,
} from "../../Redux/features/NavBar/MenuSlice";
import { useSelector, useDispatch, useStore } from "react-redux";
import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import { useAuthDetails } from "../../Common/cookiesHelper";
import ZohoIcon from "../../Assests/Dashboard/Zoho2.svg";
import ZohoYIcon from "../../Assests/Dashboard/Zoho.svg";
import TrainingIcon from "../../Assests/Dashboard/Training.svg";
import TrainingYIcon from "../../Assests/Dashboard/Training1.svg";
import LabelIcon from "../../Assests/MultipleUserIcon/label.svg";
import LabelActive from "../../Assests/MultipleUserIcon/labelactive.svg";
import UsersICcon from "../../Assests/MultipleUserIcon/user.svg";
import UserActive from "../../Assests/MultipleUserIcon/useractive.svg";
import NewsletterIcon from "../../Assests/MultipleUserIcon/newsletter.svg";
import NewsletterActive from "../../Assests/MultipleUserIcon/newsletteractive.svg";
import StoreIcon from "../../Assests/MultipleUserIcon/store.svg";
import StoreActive from "../../Assests/MultipleUserIcon/storeactive.svg";
import OrderIcon from "../../Assests/MultipleUserIcon/orderCount.svg";
import OrderActive from "../../Assests/MultipleUserIcon/ordercountactive.svg";
import DefaultIcon from "../../Assests/MultipleUserIcon/defaults.svg";
import DefaultActive from "../../Assests/MultipleUserIcon/defaultactive.svg";
import ApkIcon from "../../Assests/MultipleUserIcon/apk.svg";
import ApkActive from "../../Assests/MultipleUserIcon/apkactive.svg";
import DuplicatesIcon from "../../Assests/MultipleUserIcon/duplicates.svg";
import DuplicatesActive from "../../Assests/MultipleUserIcon/duplicatesactive.svg";
import PermissionIcon from "../../Assests/MultipleUserIcon/permission.svg";
import PermissionActive from "../../Assests/MultipleUserIcon/permissionactive.svg";
import InverntoryIcon from "../../Assests/MultipleUserIcon/inventory.svg";
import InvertoryActive from "../../Assests/MultipleUserIcon/inventoryactive.svg";
import storeIcon from "../../Assests/Manager/storeIcon.svg";
import storeIconActive from "../../Assests/Manager/storeIconActive.svg";
import ManagerIcon from "../../Assests/Manager/managerIcon.svg";
import ManagerIconActive from "../../Assests/Manager/managerIconActive.svg";

import MerchantIcon from "../../Assests/MultipleUserIcon/merchant.svg";
import MerchantActive from "../../Assests/MultipleUserIcon/merchantactive.svg";
import NestedDropdownMenu from "./NestedDropdownMenu";
import { PERMISSIONS } from "../../Constants/permission";
import Support from "../../Assests/Category/Support.svg";
import Support1 from "../../Assests/Category/Support-1.svg";
import OrderRetrieve from "../../Assests/OrderRetireve/Order_retrive.svg";
import OrderRetrievey from "../../Assests/OrderRetireve/Order_retrivey.svg";
import { generateClass } from "../../Constants/utils";
import {
  fetchPermissions,
  CheckElasticConnection,
} from "../../Redux/features/Authentication/permissionsSlice"; //CheckElasticConnection
import { fetchsystemAccessListData } from "../../Redux/features/SystemAccess/systemAccessSlice";
import { hasStoreUrlPermission, hasMenuSectionAccess, isLotteryEbtAllowed } from "../../helperFunctions/storePermissionHelper";
import { LUMANA_SUPERADMIN_ONLY, lumanaVisibleFor } from "../lumanaConnect/lumanaFormat";
import {
  BULK_SETTINGS_SUPERADMIN_ONLY,
  bulkSettingsVisibleFor,
} from "../BulkStoreSettings/bulkSettingsAccess";
import { DEPOSIT_SUPERADMIN_ONLY, canUseContainerDeposit } from "../ContainerDeposit/depositApi";
import { hasLinkPermission } from "../../helperFunctions/permissionHelper";
import { ToastifyAlert } from "../../CommonComponents/ToastifyAlert";
import useInventoryExportRestriction from "../../hooks/useInventoryExportRestriction";
import "../../Styles/SidebarWorkspace.css";

import ASKAISVG from "../../Assests/Dashboard/Chotbot.svg";
import ASKAISVGY from "../../Assests/Dashboard/ChatBoty.svg";

import ConfigIcon from "../../Assests/Superadmin/ConfigureCategory.svg";
import ConfigIconY from "../../Assests/Superadmin/ConfigureCategory1y.svg";

import CustomIcon from "../../Assests/Superadmin/QuickveeCustom.svg";
import CustomIconY from "../../Assests/Superadmin/QuickveeCustom1.svg";

import NewsletterIconnew from "../../Assests/Superadmin/Newsletter.svg";
import NewsletterIconnewY from "../../Assests/Superadmin/Newsletter1.svg";

import SMSIcon from "../../Assests/Superadmin/Sms-03-03.svg";
import SMSIconY from "../../Assests/Superadmin/Sms-03-031.svg";

import NewInventoryIcon from "../../Assests/Superadmin/InventoryDuplicate1.svg";
import NewInventoryIconY from "../../Assests/Superadmin/InventoryDuplicate2.svg";

import NewProductIcon from "../../Assests/Superadmin/ProductDuplicate.svg";
import NewProductIconY from "../../Assests/Superadmin/ProductDuplicate1.svg";


import MerchantsExport from "../../Assests/Dashboard/MerchantExport.svg";
import MerchantsExportY from "../../Assests/Dashboard/MerchantExport1.svg";
import { canViewItemSoldReport, canViewPoProductsReport } from "../../Constants/itemSoldReportAccess";

const canAccessMenuLink = (link, isStoreActiveFlag) => {
  if (!link) return true;
  if (!isStoreActiveFlag) return hasLinkPermission(link);
  return hasStoreUrlPermission(`/merchants${link}`);
};

const hasMenuItemPermission = (itemText, permissions, requiredPermission) => {
  return permissions.includes(requiredPermission);
};

/** Stable path helper — defined outside SideMenu so memoized items keep a fixed reference. */
function getFirstTwoSegmentsPath(pathname) {
  const segments = pathname?.split("/").filter(Boolean);
  return "/" + (segments?.slice(0, 2).join("/") || "");
}

/** Every link in a menu tree: top items, dropdown children, nested children. */
function collectMenuLinks(items, links = []) {
  (items || []).forEach((item) => {
    const link = String(item?.link ?? "").trim();
    if (link) links.push(link);
    collectMenuLinks(item?.dropdownItems, links);
    collectMenuLinks(item?.dropDownItems, links);
  });
  return links;
}

/**
 * Active-state checks compare the first two path segments, which misses detail
 * routes under a one-segment link (/purchase-order/10366 vs /purchase-order).
 * Keep the pathname when a link already matches that way; otherwise use the
 * most specific menu link the pathname sits under.
 */
function resolveActiveMenuPath(pathname, menuLinks) {
  if (!pathname) return pathname;
  const pathKey = getFirstTwoSegmentsPath(pathname);
  if (menuLinks.some((link) => getFirstTwoSegmentsPath(link) === pathKey)) {
    return pathname;
  }
  let parentLink = "";
  menuLinks.forEach((link) => {
    const base = link.replace(/\/+$/, "");
    if (base && pathname.startsWith(`${base}/`) && base.length > parentLink.length) {
      parentLink = base;
    }
  });
  return parentLink || pathname;
}

const HOVER_EXPANDS_RAIL =
  typeof window !== "undefined" &&
  window.matchMedia("(hover: hover) and (pointer: fine)").matches;

const SideMenu = ({
  isHoverOnNavBar,
  setIsHoverOnNavBar,
  moreThanOneStoreAvailable,
}) => {
  const AllInSystemAccessState = useSelector((state) => state.systemAccessList);
  const { LoginGetDashBoardRecordJson, LoginAllStore, userTypeData } =
    useAuthDetails();

  // Lottery menu is always visible; it is accessible only when the EBT flag
  // is 4 (store/employee). This drives the "Access Denied" gate on click.
  const isLotteryAccessible = isLotteryEbtAllowed(
    LoginGetDashBoardRecordJson?.data?.ebt,
    AllInSystemAccessState?.systemAccessData?.ebt,
  );

  const merchant_id = LoginGetDashBoardRecordJson?.data?.merchant_id;
  // Restricted stores (set by superadmin under Inventory Export) lose the
  // menu item for store/employee logins; superadmin can still export.
  const { restrictedMap: exportRestrictedMap } =
    useInventoryExportRestriction([merchant_id]);
  const isMerchantBlockedFromExport =
    exportRestrictedMap[merchant_id] === true &&
    (LoginGetDashBoardRecordJson?.login_type || userTypeData?.login_type) !==
    "superadmin";
  // console.log("merchant_id", LoginGetDashBoardRecordJson);
  const availableStoreRecords =
    (Array.isArray(LoginGetDashBoardRecordJson?.stores) &&
      LoginGetDashBoardRecordJson?.stores) ||
    (Array.isArray(LoginGetDashBoardRecordJson?.data?.stores) &&
      LoginGetDashBoardRecordJson?.data?.stores) ||
    (Array.isArray(LoginAllStore?.data?.stores) && LoginAllStore?.data?.stores) ||
    (Array.isArray(LoginAllStore?.data2?.stores) &&
      LoginAllStore?.data2?.stores) ||
    [];
  const selectedStoreRecord = availableStoreRecords.find(
    (store) => store?.merchant_id === merchant_id || store?.id === merchant_id
  );
  const enabledTobaccoScanProgramsRaw =
    LoginGetDashBoardRecordJson?.data?.enabled_tobacco_scan_programs ??
    selectedStoreRecord?.enabled_tobacco_scan_programs ??
    "";
  const enabledTobaccoScanPrograms =
    typeof enabledTobaccoScanProgramsRaw === "string"
      ? enabledTobaccoScanProgramsRaw
        .split(",")
        .map((item) => item.trim().toLowerCase())
        .filter(Boolean)
      : [];
  const hasTobaccoScanProgramAccess = enabledTobaccoScanPrograms.length > 0;
  // Land on the first scan data tab the store actually has access to, so the
  // menu link matches the tab MainScanData ends up rendering.
  const tobaccoScanLandingTab = enabledTobaccoScanPrograms.includes("altria")
    ? "AltriaForm"
    : enabledTobaccoScanPrograms.includes("circana")
      ? "ReynoldsForm"
      : "Dezi";
  const login_type =
    LoginGetDashBoardRecordJson?.login_type || userTypeData?.login_type || "";
  // const canSeeGroupManagementMenu = login_type === "merchant" || login_type === "superadmin";
  const canSeeGroupManagementMenu = login_type === "superadmin";
  // Same redux slice `permissions` is read from again below (line ~1934) for the
  // main permission-filter pass — needed here too, earlier, because menuItems
  // (built right below) already needs it for canViewItemSoldReport's role check.
  const { permissions: permissionsForMenuItems } = useSelector(
    (state) => state.permissions,
  );
  const bulkUpdatesMenuItem = {
    id: 90010,
    icon: (
      <img
        src={ProductIcon}
        alt="Bulk Product Update"
        className="h-6 w-10 mt-4 mb-4 hoverable-image"
      />
    ),
    activeIcon: (
      <img
        src={ProdIcon}
        alt="Bulk Product Update"
        className="h-6 w-10 mt-4 mb-4 "
      />
    ),
    text: "Bulk Updates",
    link: "/inventory/bulk-product-update",
    className: "Bulk-Updates-for-android",
  };
  // const isLottery = "0";
  const menuItems = [
    {
      id: 1,
      icon: (
        <img
          src={DashIcon}
          alt="Dashboard"
          className="h-6 w-10 mt-4 mb-4 hoverable-image"
        />
      ),
      activeIcon: (
        <img
          src={DashboardIcon}
          alt="Dashboard"
          className="h-6 w-10 mt-4 mb-4"
        />
      ),
      text: "Dashboard",
      link: "/dashboard",
      className: "Dashboard-for-android",
    },
    // Sale Register menu — superadmin only
    ...(LoginGetDashBoardRecordJson?.login_type === "superadmin"
      ? [
        {
          id: 99001,
          icon: (
            <img
              src={SaleRegisterIcon}
              alt="Sale Register"
              className="h-6 w-10 mt-4 mb-4 hoverable-image"
            />
          ),
          activeIcon: (
            <img
              src={SaleRegisterIcon}
              alt="Sale Register"
              className="h-6 w-10 mt-4 mb-4"
            />
          ),
          text: "Sale Register",
          link: "/web-register",
          alwaysNewTab: true,
          className: "sale-register-neon",
        },
      ]
      : []),
    // {
    //   id: 1747039070379,
    //   icon: (
    //     <img
    //       src={DashIcon}
    //       alt="Dashboard"
    //       className="h-6 w-10 mt-4 mb-4 hoverable-image"
    //     />
    //   ),
    //   activeIcon: (
    //     <img
    //       src={DashboardIcon}
    //       alt="Node Dashboard"
    //       className="h-6 w-10 mt-4 mb-4"
    //     />
    //   ),
    //   text: "Node Dashboard",
    //   link: "/node-dashboard",
    //   className: "Dashboard-for-android",
    // },
    {
      id: 243535678788788,
      icon: (
        <img
          src={ShoppingCartIcon}
          alt="Order"
          className="h-6 w-10 mt-4 mb-4 hoverable-image"
        />
      ),
      activeIcon: (
        <img src={OrderYellow} alt="order" className="h-6 w-10 mt-4 mb-4" />
      ),
      text: "Orders",
      link: "/order-new",
      className: "Orders-for-android",
    },

    {
      id: 1733993556287,
      icon: (
        <img
          src={Customer_icon}
          alt="Customer"
          className="h-6 w-10 mt-4 mb-4"
        />
      ),
      activeIcon: (
        <img
          src={Customer_Active_icon}
          alt="Customer"
          className="h-6 w-10 mt-4 mb-4 "
        />
      ),
      text: "Customer Management",
      link: "/customer-management",
      className: "Customer-Management-for-android",
      dropdownItems: [
        {
          id: 1,
          text: "Customers",
          link: "/customer-management",
          className: "Customer-Management-for-android",
        },
        ...(canSeeGroupManagementMenu
          ? [
            {
              id: 70,
              icon: (
                <img
                  src={AttributesIcon}
                  alt="create-group"
                  className="h-6 w-10 mt-4 mb-4 hoverable-image"
                />
              ),
              activeIcon: (
                <img
                  src={AtriIcon}
                  alt="atributes"
                  className="h-6 w-10 mt-4 mb-4"
                />
              ),
              text: "Customer  Groups",
              link: "/customer-management/customer-groups",
              className: "Create-Store-for-android superadminGreen",
            },
          ]
          : []),
      ],
    },
    {
      id: 111111,
      icon: (
        <img
          src={Loyalty}
          alt="Loyalty Program"
          className="h-6 w-10 mt-4 mb-4 hoverable-image"
        />
      ),
      activeIcon: (
        <img src={LoyaltIcon} alt="Import" className="h-6 w-10 mt-4 mb-4 " />
      ),
      text: "Loyalty Program",
      link: "/loyalty-program",
      className: "Loyalty-Program-for-android",
    },
    {
      id: 123456,
      icon: (
        <img
          src={MixMatchIcon}
          alt="Promotions"
          className="h-6 w-10 mt-4 mb-4 hoverable-image"
        />
      ),
      activeIcon: (
        <img src={MixMatchIcon1} alt="Import" className="h-6 w-10 mt-4 mb-4 " />
      ),
      text: "Promotions",
      className: "Promotions-for-android",
      dropdownItems: [
        // {
        //   id: 9,
        //   icon: (
        //     <img
        //       src={MixMatchIcon}
        //       alt="mix-match-icon"
        //       className="h-6 w-10 mt-4 mb-4"
        //     />
        //   ),
        //   activeIcon: (
        //     <img
        //       src={MixMatchIcon1}
        //       alt="mix-match-icon-1"
        //       className="h-6 w-10 mt-4 mb-4 "
        //     />
        //   ),
        //   text: "Mix N' Match Pricing",
        //   link: "/mix-and-match",
        //   className:
        //     "Mix-And-Match-Pricing-for-android Mix-N'-Match-Pricing-for-android",
        // },

        // {
        //   id: 8,
        //   icon: (
        //     <img
        //       src={CouponIcon}
        //       alt="Coupons"
        //       className="h-6 w-10 mt-4 mb-4"
        //     />
        //   ),
        //   activeIcon: (
        //     <img src={CouIcon} alt="Coupons" className="h-6 w-10 mt-4 mb-4 " />
        //   ),
        //   text: "Coupons",
        //   link: "/promotions/coupons",
        //   className: "Coupons-for-android",
        // },
        {
          id: 1712847392,
          icon: (
            <img
              src={CouponIcon}
              alt="Coupons"
              className="h-6 w-10 mt-4 mb-4"
            />
          ),
          activeIcon: (
            <img src={CouIcon} alt="Coupons" className="h-6 w-10 mt-4 mb-4 " />
          ),
          text: "Coupons",
          link: "/promotions/coupons/order-coupons",
          className: "Coupons-for-android",
        },

        {
          id: 10,
          icon: (
            <img
              src={MixMatchIcon}
              alt="bogo-pricing-icon"
              className="h-6 w-10 mt-4 mb-4"
            />
          ),
          activeIcon: (
            <img
              src={MixMatchIcon1}
              alt="bogo-pricing-icon-1"
              className="h-6 w-10 mt-4 mb-4 "
            />
          ),
          text: "BOGO Pricing",
          link: "/promotions/bogo-pricing",
          className:
            "Mix-And-Match-Pricing-for-android Mix-N'-Match-Pricing-for-android",
        },
        {
          id: 9,
          icon: (
            <img
              src={MixMatchIcon}
              alt="mix-match-icon"
              className="h-6 w-10 mt-4 mb-4"
            />
          ),
          activeIcon: (
            <img
              src={MixMatchIcon1}
              alt="mix-match-icon-1"
              className="h-6 w-10 mt-4 mb-4 "
            />
          ),
          text: "Mix N' Match Pricing",
          link: "/promotions/mix-and-match",
          className:
            "Mix-And-Match-Pricing-for-android Mix-N'-Match-Pricing-for-android",
        },
        {
          // Customer feed sits with the promotions because it is the same job:
          // getting something in front of customers who follow this store.
          id: 1774000000001,
          icon: (
            <img
              src={MixMatchIcon}
              alt="customer-feed-icon"
              className="h-6 w-10 mt-4 mb-4"
            />
          ),
          activeIcon: (
            <img
              src={MixMatchIcon1}
              alt="customer-feed-icon-1"
              className="h-6 w-10 mt-4 mb-4 "
            />
          ),
          text: "Customer Feed",
          link: "/customer-feed/posts",
          className: "Customer-Feed-for-android",
        },
        {
          id: 1774000000002,
          icon: (
            <img
              src={MixMatchIcon}
              alt="gift-card-icon"
              className="h-6 w-10 mt-4 mb-4"
            />
          ),
          activeIcon: (
            <img
              src={MixMatchIcon1}
              alt="gift-card-icon-1"
              className="h-6 w-10 mt-4 mb-4 "
            />
          ),
          text: "Gift Card",
          link: "/promotions/gift-card",
          className: "Gift-Card-for-android",
        },
        // {
        //   id: 1756094087718,
        //   icon: (
        //     <img
        //       src={MixMatchIcon}
        //       alt="product-and-category-discounts-icon"
        //       className="h-6 w-10 mt-4 mb-4"
        //     />
        //   ),
        //   activeIcon: (
        //     <img
        //       src={MixMatchIcon1}
        //       alt="product-and-category-discounts-icon-1"
        //       className="h-6 w-10 mt-4 mb-4 "
        //     />
        //   ),
        //   text: "Product And Category Discounts",
        //   link: "/promotions/product-and-category-discounts",
        //   className: "Product-And-Category-Discounts-for-android",
        // },
      ],
    },
    {
      id: 3,
      icon: (
        <img
          src={ReportIcon}
          alt="store"
          className="h-6 w-10 mt-4 mb-4 hoverable-image"
        />
      ),
      activeIcon: (
        <img
          src={ResportIcons}
          alt="active report"
          className="h-6 w-10 mt-4 mb-4"
        />
      ),
      text: "Reporting",
      link: "/reporting",
      className: "Reporting-for-android",
      dropdownItems: [
        // {
        //   id: 1,
        //   text: "Sales Reports",
        //   dropDownItems: [
        //     {
        //       id: 61,
        //       text: "Sales Summary",
        //       link: "/store-reporting/sales-report",
        //     },
        //     {
        //       id: 108,
        //       text: "Sales Report",
        //       link: "/store-reporting/new-sales-report",
        //     },
        //     {
        //       id: 77,
        //       text: "Item Sales",
        //       link: "/store-reporting/item-sales",
        //     },
        //     {
        //       id: 98,
        //       text: "Category Sales Summary Report",
        //       link: "/store-reporting/category-sales-summery-report",
        //     },
        //     {
        //       id: 62,
        //       text: "Daily Total Report",
        //       link: "/store-reporting/daily-total-report",
        //     },
        //     {
        //       id: 63,
        //       text: "Detailed Category Sale",
        //       link: "/store-reporting/Details-category",
        //     },
        //     {
        //       id: 64,
        //       text: "Detailed Sales Person Report",
        //       link: "/store-reporting/report-sales-person",
        //     },

        //     {
        //       id: 96,
        //       text: "Drop Cash Report",
        //       link: "/store-reporting/drop-cash-report",
        //     },
        //     {
        //       id: 102,
        //       text: "Gift Card Report",
        //       link: "/store-reporting/gift-card-report",
        //     },

        //     {
        //       id: 79,
        //       text: "Order Type",
        //       link: "/store-reporting/order-type",
        //     },
        //     {
        //       id: 97,
        //       text: "Pay In Report",
        //       link: "/store-reporting/pay-in-report",
        //     },
        //     {
        //       id: 78,
        //       text: "Payment Method Details",
        //       link: "/store-reporting/payment-method-details",
        //     },
        //     {
        //       id: 90,
        //       text: "Product Profitability Report",
        //       link: "/store-reporting/item-sale-profit-report",
        //     },
        //     // {
        //     //   id: 99,
        //     //   text: "Sales by Hour Report",
        //     //   link: "/store-reporting/sales-by-hour-report",
        //     // },

        //     {
        //       id: 69,
        //       text: "Top Sellers",
        //       link: "/store-reporting/overall-top",
        //     },

        //     // {
        //     //   id: 78,
        //     //   text: "Discount Per Sales Report",
        //     //   link: "/store-reporting/discount-per-sales-report",
        //     // },

        //     // {
        //     //   id: 105,
        //     //   text: "New Item Sales Report",
        //     //   link: "/store-reporting/new-item-sales-report",
        //     // },
        //   ],
        // },
        {
          id: 80,
          text: "Sales",
          link: "/store-reporting/new-sale-report/sales-summary",
          className: "Sales-Reports-for-android",
        },
        // {
        //   id: 2,
        //   text: "Inventory Reports",
        //   dropDownItems: [
        //     {
        //       id: 81,
        //       text: "Current Inventory Value11",
        //       link: "/store-reporting/current-inventory-value",
        //     },
        //     {
        //       id: 73,
        //       text: "New Item Created Between",
        //       link: "/store-reporting/item-create-between",
        //     },
        //     {
        //       id: 74,
        //       text: "Reorder Inventory",
        //       link: "/store-reporting/recorder-inventory",
        //     },
        //     {
        //       id: 68,
        //       text: "Instant PO Activity Report",
        //       link: "/store-reporting/instant-activity",
        //     },
        //     {
        //       id: 65,
        //       text: "Check ID verification",
        //       link: "/store-reporting/id-verification",
        //     },
        //     {
        //       id: 93,
        //       text: "Inventory List",
        //       link: "/store-reporting/inventory-list",
        //     },
        //     {
        //       id: 94,
        //       text: "Profit Margin Per Item Listing",
        //       link: "/store-reporting/profit-margin-report",
        //     },
        //   ],
        // },
        {
          id: 2,
          text: "Inventory",
          link: "/store-reporting/inventory-report/recorder-inventory",
          // link: "/store-reporting/inventory-report/quantity-history-report",
          className: "Inventory-Reports-for-android",
        },
        {
          id: 1729761292981,
          text: "Customers",
          link: "/store-reporting/customer-reports/customers",
          className: "Customer-Reports-for-android",
        },
        {
          id: 1729851529495,
          text: "Employees",
          link: "/store-reporting/employee-reports/employee-list",
          className: "Employee-Reports-for-android",
        },
        {
          id: 116,
          text: "Payments",
          link: "/store-reporting/payment-report",
          className: "Payment-Report-for-android",
        },
        // {
        //   id: 1726123837135,
        //   text: "Register Activity",
        //   link: `/store-reporting/register-activity/${!AllInSystemAccessState?.loading &&
        //     AllInSystemAccessState?.systemAccessData &&
        //     AllInSystemAccessState?.systemAccessData?.shift_assign !== "1"
        //       ? "register-closures"
        //       : "drop-cash"}`,
        //   className: "Register-Activity-for-android",
        // },
        {
          id: 1726123837135,
          text: "Refunds",
          link: "/store-reporting/refund-report-main/order-refund-report",
          className: "Refund-Report-for-android",
        },
        {
          id: 1728556297041,
          text: "Register Activity",
          link: `/store-reporting/register-activity/register-closures`,
          className: "Register-Activity-for-android",
        },
        {
          id: 1728561041725,
          text: "Loyalty",
          link: "/store-reporting/detailed-loyalty-points-report",
          className: "Loyalty-Report-for-android",
        },

        // {
        //   id: 4,
        //   text: "Refunds",
        //   dropDownItems: [
        //     {
        //       id: 84,
        //       text: "Item Refund Report",
        //       link: "/store-settings/refund-report",
        //     },
        //     {
        //       id: 82,
        //       text: "Order Refund Report",
        //       link: "/store-settings/order-refund-report",
        //     },
        //     // {
        //     //   id: 85,
        //     //   text: "Refunded Order ID's",
        //     //   link: "/store-settings/#",
        //     // },
        //   ],
        // },
        {
          id: 1729596404509,
          text: "Store Credit",
          link: "/store-reporting/store-credit-report",
          className: "Store-Credit-Report-for-android",
        },

        {
          id: 172959640451101,
          text: "Gift Cards",
          link: "/store-reporting/gift-card-report",
          className: "Gift-Card-Reports-for-android",
        },

        {
          id: 1732688013753,
          text: "Taxes",
          link: "/store-reporting/new-taxes-report",
          className: "Tax-Report-for-android",
        },
        {
          id: 1740750000000,
          text: "Location Report",
          link: "/store-reporting/location-report",
          className: "Location-Report-for-android",
        },
        // Item Sold Report — pilot stores only (isItemSoldReportStore: listed ID or owner email),
        // role-gated via its own "ISR" permission (see submenuPermissionMap.Reporting
        // below + canViewItemSoldReport).
        ...(canViewItemSoldReport(merchant_id, permissionsForMenuItems, PERMISSIONS.MENU_ITEM_SOLD_REPORT, LoginGetDashBoardRecordJson?.data?.email)
          ? [{
            id: 1740750100000,
            text: "Item Sold Report",
            link: "/store-reporting/item-sold-report",
            className: "Item-Sold-Report-for-android",
          }]
          : []),
        // Category Sold Report — same pilot merchant gate as Item Sold Report
        // above (same new report pipeline, rolled up by category instead of
        // item), but its own "CSR" permission — not interchangeable with ISR.
        ...(canViewItemSoldReport(merchant_id, permissionsForMenuItems, PERMISSIONS.MENU_CATEGORY_SOLD_REPORT, LoginGetDashBoardRecordJson?.data?.email)
          ? [{
            id: 1740750110000,
            text: "Category Sold Report",
            link: "/store-reporting/category-sold-report",
            className: "Category-Sold-Report-for-android",
          }]
          : []),
        // PO Products Report — same pilot merchant gate as Category Sold
        // Report, but its own "PPR" permission (canViewPoProductsReport).
        ...(canViewPoProductsReport(merchant_id, permissionsForMenuItems, LoginGetDashBoardRecordJson?.data?.email)
          ? [{
            id: 1740750120000,
            text: "PO Products Report",
            link: "/store-reporting/po-products-report",
            className: "PO-Products-Report-for-android",
          }]
          : []),

        ...(LoginGetDashBoardRecordJson?.data?.delivery_company?.toLowerCase() === "uber" && LoginGetDashBoardRecordJson?.login_type === "superadmin"
          ? [{
            id: 1739400000000,
            text: "Uber Reports",
            link: "/store-reporting/uber-reports/delivery-report",
            className: "Uber-Reports-for-android",
          }]
          : []),

        ...(LoginGetDashBoardRecordJson?.data?.delivery_company?.toLowerCase() === "uber" && LoginGetDashBoardRecordJson?.login_type !== "superadmin"
          ? [{
            id: 1769000000001,
            text: "Uber Delivery Charges",
            link: "/store-reporting/uber-reports/delivery-charges",
            className: "Uber-Delivery-Charges-for-android",
          }]
          : []),

        // {
        //   id: 1728561073906,
        //   text: "Employee Hours",
        //   link: "##",
        // },

        // {
        //   id: 1723011930198,
        //   text: "Employee Reports",
        //   dropDownItems: [
        //     {
        //       id: 102,
        //       text: "Employee Sales Per Category",
        //       link: "/store-reporting/employee-sales-per-category-report",
        //     },
        //   ],
        // },
        // { id: 80, text: "Taxes ", link: "/store-reporting/taxes-report" },

        // {
        //   id: 66,
        //   text: "Vendor Sales Report",
        //   link: "/store-reporting/vendors-sales-reports",
        // },
        // {
        //   id: 90,
        //   text: "Item Sales Profit Report",
        //   link: "/store-reporting/item-sale-profit-report",
        // },
        // {
        //   id: 67,
        //   text: "Credit Debit Sales Report",
        //   link: "/store-reporting/credit-debit-sales",
        // },

        // { id: 70, text: "Flash Report", link: "/store-reporting/flash-resigter" },

        // { id: 76, text: "Shift Summary", link: "/store-reporting/shift-summary" },

        // { id: 77, text: " Item Sales ", link: "/store-settings/item-sales" },
        // {
        //   id: 78,
        //   text: " Payment Method Details",
        //   link: "/store-settings/payment-method-detail-report",
        // },

        // { id: 77, text: " Item Sales ", link: "/store-reporting/item-sales" },
        // { id: 87, text: "Tip Report", link: "/store-reporting/tip-report" },
        // { id: 88, text: "Coupon Report", link: "/store-reporting/coupon-report" },
        // { id: 1726033807930, text: "Shift Summary", link: "/store-reporting/shift-summary" },

        // {
        //   id: 89,
        //   text: "Discount Per Sales Person",
        //   link: "/store-reporting/discount-per-sales-report",
        // },
        // {
        //   id: 6,
        //   text: "New Reports",
        //   dropDownItems: [
        //     {
        //       id: 104,
        //       text: "Profit Summary Report",
        //       link: "/store-reporting/profit-summary-report",
        //     },
        //   ],
        // },
      ],
    },
    {
      id: 4,
      icon: (
        <img
          src={Inventory_Icon}
          alt="Products"
          className="h-6 w-10 mt-4 mb-4 hoverable-image"
        />
      ),
      activeIcon: (
        <img
          src={Inventory_Active_Icon}
          alt="Category"
          className="h-6 w-10 mt-4 mb-4 "
        />
      ),
      text: "Inventory",
      className: "Inventory-for-android",
      dropdownItems: [
        {
          id: 90006,
          icon: (
            <img
              src={ProductIcon}
              alt="Products"
              className="h-6 w-10 mt-4 mb-4 hoverable-image"
            />
          ),
          activeIcon: (
            <img src={ProdIcon} alt="Products" className="h-6 w-10 mt-4 mb-4 " />
          ),
          text: "Products",
          link: "/inventory/new-products",
          className: "Products-for-android",
        },
        {
          id: 1760200002,
          icon: (
            <img
              src={ProductIcon}
              alt="Variants"
              className="h-6 w-10 mt-4 mb-4 hoverable-image"
            />
          ),
          activeIcon: (
            <img src={ProdIcon} alt="Variants" className="h-6 w-10 mt-4 mb-4 " />
          ),
          text: "Variants",
          link: "/inventory/variants",
          className: "Products-for-android",
        },
        {
          id: 2,
          icon: (
            <img
              src={CategoryIconActive}
              alt="Category"
              className="h-6 w-10 mt-4 mb-4 hoverable-image"
            />
          ),
          activeIcon: (
            <img src={CatIcon} alt="Category" className="h-6 w-10 mt-4 mb-4 " />
          ),
          text: "Categories",
          link: "/inventory/category",
          className: "Category-for-android",
        },
        {
          id: 90003,
          icon: (
            <img
              src={AttributesIcon}
              alt="Attributes"
              className="h-6 w-10 mt-4 mb-4 hoverable-image"
            />
          ),
          activeIcon: (
            <img src={AtriIcon} alt="Attributes" className="h-6 w-10 mt-4 mb-4" />
          ),
          text: "Attributes",
          link: "/inventory/attributes",
          className: "Attributes-for-android",
        },
        {
          id: 90002,
          icon: (
            <img
              src={AttributesIcon}
              alt="Brands"
              className="h-6 w-10 mt-4 mb-4 hoverable-image"
            />
          ),
          activeIcon: (
            <img src={AtriIcon} alt="Brands" className="h-6 w-10 mt-4 mb-4" />
          ),
          text: "Brands",
          link: "/inventory/brands",
          className: "Brand-for-android",
        },
        {
          id: 90004,
          icon: (
            <img
              src={AttributesIcon}
              alt="Tags"
              className="h-6 w-10 mt-4 mb-4 hoverable-image"
            />
          ),
          activeIcon: (
            <img src={AtriIcon} alt="Tags" className="h-6 w-10 mt-4 mb-4" />
          ),
          text: "Tags",
          link: "/inventory/tags",
          className: "Tag-for-android",
        },
        {
          id: 1760300001,
          icon: (
            <img
              src={ProductIcon}
              alt="Composite Items"
              className="h-6 w-10 mt-4 mb-4 hoverable-image"
            />
          ),
          activeIcon: (
            <img
              src={ProdIcon}
              alt="Composite Items"
              className="h-6 w-10 mt-4 mb-4 "
            />
          ),
          text: "Composite Items",
          link: "/inventory/composite-items",
          className: "Composite-items-for-android",
        },
        // Lottery is always visible. Access is gated on click by the EBT flag
        // (allowed only when EBT === 4); otherwise the shared "Access Denied"
        // flow in handleItemClick runs, same as every other menu item.
        {
          id: 1726725862759,
          icon: (
            <img
              src={AttributesIcon}
              alt="Lottery"
              className="h-6 w-10 mt-4 mb-4 hoverable-image"
            />
          ),
          activeIcon: (
            <img
              src={AtriIcon}
              alt="Lottery"
              className="h-6 w-10 mt-4 mb-4"
            />
          ),
          text: "Lottery",
          link: "/inventory/lottery",
          lotteryAccessAllowed: isLotteryAccessible,
        },
        ...(canUseContainerDeposit({ LoginGetDashBoardRecordJson, userTypeData }, permissionsForMenuItems)
          ? [
            {
              id: 1760300002,
              icon: (
                <img
                  src={ProductIcon}
                  alt="Container Deposit"
                  className="h-6 w-10 mt-4 mb-4 hoverable-image"
                />
              ),
              activeIcon: (
                <img
                  src={ProdIcon}
                  alt="Container Deposit"
                  className="h-6 w-10 mt-4 mb-4 "
                />
              ),
              text: "Container Deposit",
              link: "/inventory/container-deposit",
              className: DEPOSIT_SUPERADMIN_ONLY
                ? "Container-deposit-for-android superadminGreen"
                : "Container-deposit-for-android",
            },
          ]
          : []),
        {
          id: 1766484630999,
          icon: (
            <img src={Vendor_Icon} alt="Vendors" className="h-6 w-10 mt-4 mb-4" />
          ),
          activeIcon: (
            <img
              src={Vendor_Active_icon}
              alt="Vendors"
              className="h-6 w-10 mt-4 mb-4 "
            />
          ),
          text: "Vendors",
          link: "/inventory/vendors",
          className: "Vendors-for-android",
        },
        // Access gated by BULKP; position set by the user (2026-08-31).
        bulkUpdatesMenuItem,
        // Packaging (unit / manufacturer master lists): MP for employees.
        {
          id: 1760300003,
          icon: (
            <img
              src={AttributesIcon}
              alt="Packaging"
              className="h-6 w-10 mt-4 mb-4 hoverable-image"
            />
          ),
          activeIcon: (
            <img
              src={AtriIcon}
              alt="Packaging"
              className="h-6 w-10 mt-4 mb-4"
            />
          ),
          text: "Packaging",
          link: "/inventory/packaging",
          className: "Product-lookups-for-android",
        },
        // {
        //   id: 1726725862759,
        //   icon: (
        //     <img
        //       src={AttributesIcon}
        //       alt="Lottery"
        //       className="h-6 w-10 mt-4 mb-4 hoverable-image"
        //     />
        //   ),
        //   activeIcon: (
        //     <img src={AtriIcon} alt="Lottery" className="h-6 w-10 mt-4 mb-4" />
        //   ),
        //   text: "Lottery",
        //   link: "/inventory/lottery",
        // },
        // {
        //   id: 1728378243020,
        //   icon: (
        //     <img
        //       src={MixMatchIcon}
        //       alt="mix-match-icon"
        //       className="h-6 w-10 mt-4 mb-4"
        //     />
        //   ),
        //   activeIcon: (
        //     <img
        //       src={MixMatchIcon1}
        //       alt="mix-match-icon-1"
        //       className="h-6 w-10 mt-4 mb-4 "
        //     />
        //   ),
        //   text: "Mix N' Match Pricing",
        //   link: "/inventory/mix-and-match",
        // },
      ],
    },
    // Stock Control: counting, ordering and moving stock. Each page keeps its
    // own route permission (ASOH, AP, AK, ITA), checked on click.
    {
      id: 1761000001,
      // Inline SVG (same technique as Product Sync) so the rail's CSS stroke
      // recolors it, and we never depend on a separate image asset loading.
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#8a9ba8"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="h-6 w-6 shrink-0 hoverable-image"
          style={{ width: "24px", height: "24px" }}
          aria-hidden="true"
        >
          <rect x="8.5" y="3.5" width="12" height="9.5" rx="1.6" />
          <path d="M8.5 7.5h12" />
          <rect x="3.5" y="10.5" width="12" height="9.5" rx="1.6" />
          <path d="M3.5 14.5h12" />
        </svg>
      ),
      activeIcon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#0A64F9"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="h-6 w-6 shrink-0"
          style={{ width: "24px", height: "24px" }}
          aria-hidden="true"
        >
          <rect x="8.5" y="3.5" width="12" height="9.5" rx="1.6" />
          <path d="M8.5 7.5h12" />
          <rect x="3.5" y="10.5" width="12" height="9.5" rx="1.6" />
          <path d="M3.5 14.5h12" />
        </svg>
      ),
      text: "Stock Control",
      className: "Stock-control-for-android",
      dropdownItems: [
        {
          id: 90006,
          icon: (
            <img
              src={PurchaseIcon}
              alt="Purchase Order"
              className="h-6 w-10 mt-4 mb-4 hoverable-image"
            />
          ),
          activeIcon: (
            <img
              src={PurIcon}
              alt="Purchase Order"
              className="h-6 w-10 mt-4 mb-4"
            />
          ),
          text: "Purchase Order",
          link: "/purchase-order",
          className: "New-Purchase-Order-for-android",
        },
        {
          id: 12554323453423425443224,
          icon: (
            <img
              src={Stock_take_Icon}
              alt="Stocktake"
              className="h-6 w-10 mt-4 mb-4 hoverable-image"
            />
          ),
          activeIcon: (
            <img
              src={Stock_take_Active_Icon}
              alt="Stocktake"
              className="h-6 w-10 mt-4 mb-4"
            />
          ),
          text: "Stocktake",
          link: "/stocktake-app",
          className: "Stocktake-for-android",
        },
        // Stock on Hand — ASOH for employees (merchant/superadmin bypass route gate).
        {
          id: 90011,
          text: "Stock on Hand",
          link: "/stock-on-hand",
          className: "Stock-On-Hand-for-android",
        },
        {
          id: 1760200001,
          icon: (
            <img
              src={ProductIcon}
              alt="Transfers"
              className="h-6 w-10 mt-4 mb-4 hoverable-image"
            />
          ),
          activeIcon: (
            <img
              src={ProdIcon}
              alt="Transfers"
              className="h-6 w-10 mt-4 mb-4 "
            />
          ),
          text: "Transfers",
          link: "/inventory/transfer",
          className: "Inventory-transfer-for-android",
        },
      ],
    },
    // Vendors is not a top-level menu — it lives under Inventory
    // ("Vendors" → /inventory/vendors).
    {
      id: 7,
      icon: (
        <img
          src={Employees_Icon}
          alt="Employees"
          className="h-6 w-10 mt-4 mb-4 hoverable-image"
        />
      ),
      activeIcon: (
        <img
          src={Employees_Active_Icon}
          alt="Import"
          className="h-6 w-10 mt-4 mb-4 "
        />
      ),
      text: "Employees",
      className: "Employees-for-android",
      dropdownItems: [
        // {
        //   id: 1,
        //   text: "Employees",
        //   link: "/#",
        // },
        {
          id: 1766484630986,
          icon: (
            <img
              src={CouponIcon}
              alt="Add Employee"
              className="h-6 w-10 mt-4 mb-4"
            />
          ),
          activeIcon: (
            <img src={CouIcon} alt="option" className="h-6 w-10 mt-4 mb-4 " />
          ),
          text: "Manage Employees",
          link: "/employee/manage-employees",
          className: "Manage-Employees-for-android",
        },
        // {
        //   id: 1757910573688,
        //   icon: (
        //     <img
        //       src={CouponIcon}
        //       alt="Add Employee"
        //       className="h-6 w-10 mt-4 mb-4"
        //     />
        //   ),
        //   activeIcon: (
        //     <img
        //       src={CouIcon}
        //       alt="permission-presets"
        //       className="h-6 w-10 mt-4 mb-4 "
        //     />
        //   ),
        //   text: "Permission Presets",
        //   link: "/employee/permission-presets",
        //   className: "Permission-Presets-for-android",
        // },
        {
          id: 2311135466566546456788,
          icon: (
            <img
              src={timesheetblackIcon}
              alt={
                LoginGetDashBoardRecordJson?.login_type === "superadmin"
                  ? "New Timesheet"
                  : "Timesheet"
              }
              className="h-6 w-10 mt-4 mb-4 hoverable-image"
            />
          ),
          activeIcon: (
            <img
              src={TimesheetsIcon}
              alt={
                LoginGetDashBoardRecordJson?.login_type === "superadmin"
                  ? "New Timesheet"
                  : "Timesheet"
              }
              className="h-6 w-10 mt-4 mb-4 "
            />
          ),
          text:
            LoginGetDashBoardRecordJson?.login_type === "superadmin"
              ? "Timesheet Card"
              : "Timesheet",
          link: "/employee/new-timesheet",
          className: "New-Timesheet-for-android",
        },
        // ...(LoginGetDashBoardRecordJson?.login_type === "superadmin"
        //   ? [
        //       {
        //         id: 231113,
        //         icon: (
        //           <img
        //             src={timesheetblackIcon}
        //             alt="Timesheet"
        //             className="h-6 w-10 mt-4 mb-4 hoverable-image"
        //           />
        //         ),
        //         activeIcon: (
        //           <img
        //             src={TimesheetsIcon}
        //             alt="Timesheet"
        //             className="h-6 w-10 mt-4 mb-4 "
        //           />
        //         ),
        //         text: "New Timesheet",
        //         link: "/employee/timesheets/Daily-Review",
        //         className: "Timesheet-for-android",
        //       },
        //     ]
        //   : []),
      ],
    },

    // {
    //   id: 8,
    //   icon: <img src={CouponIcon} alt="Coupons" className="h-6 w-10 mt-4 mb-4" />,
    //   activeIcon: (
    //     <img src={CouIcon} alt="Coupons" className="h-6 w-10 mt-4 mb-4 " />
    //   ),
    //   text: "Coupons",
    //   link: "/coupons",
    //   className: "Coupons-for-android",
    // },

    // {
    //   id: 9,
    //   icon: (
    //     <img
    //       src={MixMatchIcon}
    //       alt="mix-match-icon"
    //       className="h-6 w-10 mt-4 mb-4"
    //     />
    //   ),
    //   activeIcon: (
    //     <img
    //       src={MixMatchIcon1}
    //       alt="mix-match-icon-1"
    //       className="h-6 w-10 mt-4 mb-4 "
    //     />
    //   ),
    //   text: "Mix N' Match Pricing",
    //   link: "/mix-and-match",
    //   className:
    //     "Mix-And-Match-Pricing-for-android Mix-N'-Match-Pricing-for-android",
    // },
    // {
    //   id: 123456,
    //   icon: (
    //     <img
    //       src={MixMatchIcon}
    //       alt="Promotions"
    //       className="h-6 w-10 mt-4 mb-4 hoverable-image"
    //     />
    //   ),
    //   activeIcon: (
    //     <img src={MixMatchIcon1} alt="Import" className="h-6 w-10 mt-4 mb-4 " />
    //   ),
    //   text: "Promotions",
    //   className: "Promotions-for-android",
    //   dropdownItems: [
    //     // {
    //     //   id: 9,
    //     //   icon: (
    //     //     <img
    //     //       src={MixMatchIcon}
    //     //       alt="mix-match-icon"
    //     //       className="h-6 w-10 mt-4 mb-4"
    //     //     />
    //     //   ),
    //     //   activeIcon: (
    //     //     <img
    //     //       src={MixMatchIcon1}
    //     //       alt="mix-match-icon-1"
    //     //       className="h-6 w-10 mt-4 mb-4 "
    //     //     />
    //     //   ),
    //     //   text: "Mix N' Match Pricing",
    //     //   link: "/mix-and-match",
    //     //   className:
    //     //     "Mix-And-Match-Pricing-for-android Mix-N'-Match-Pricing-for-android",
    //     // },

    //     {
    //       id: 8,
    //       icon: (
    //         <img
    //           src={CouponIcon}
    //           alt="Coupons"
    //           className="h-6 w-10 mt-4 mb-4"
    //         />
    //       ),
    //       activeIcon: (
    //         <img src={CouIcon} alt="Coupons" className="h-6 w-10 mt-4 mb-4 " />
    //       ),
    //       text: "Coupons",
    //       link: "/promotions/coupons",
    //       className: "Coupons-for-android",
    //     },

    //     {
    //       id: 10,
    //       icon: (
    //         <img
    //           src={MixMatchIcon}
    //           alt="bogo-pricing-icon"
    //           className="h-6 w-10 mt-4 mb-4"
    //         />
    //       ),
    //       activeIcon: (
    //         <img
    //           src={MixMatchIcon1}
    //           alt="bogo-pricing-icon-1"
    //           className="h-6 w-10 mt-4 mb-4 "
    //         />
    //       ),
    //       text: "BOGO Pricing",
    //       link: "/promotions/bogo-pricing",
    //       className:
    //         "Mix-And-Match-Pricing-for-android Mix-N'-Match-Pricing-for-android",
    //     },
    //     {
    //       id: 9,
    //       icon: (
    //         <img
    //           src={MixMatchIcon}
    //           alt="mix-match-icon"
    //           className="h-6 w-10 mt-4 mb-4"
    //         />
    //       ),
    //       activeIcon: (
    //         <img
    //           src={MixMatchIcon1}
    //           alt="mix-match-icon-1"
    //           className="h-6 w-10 mt-4 mb-4 "
    //         />
    //       ),
    //       text: "Mix N' Match Pricing",
    //       link: "/mix-and-match",
    //       className:
    //         "Mix-And-Match-Pricing-for-android Mix-N'-Match-Pricing-for-android",
    //     },
    //   ],
    // },

    {
      id: 65,
      icon: <img src={Tax_Icon} alt="Coupons" className="h-6 w-10 mt-4 mb-4" />,
      activeIcon: (
        <img
          src={Tax_Active_Icon}
          alt="Coupons"
          className="h-6 w-10 mt-4 mb-4 "
        />
      ),
      text: "Taxes",
      link: "/taxes",
      className: "Taxes-for-android",
    },
    {
      id: 10,
      icon: (
        <img
          src={StoreSettingIcon}
          alt="store"
          className="h-6 w-10 mt-4 mb-4 hoverable-image"
        />
      ),
      activeIcon: (
        <img
          src={SettingIcon}
          alt="active store"
          className="h-6 w-10 mt-4 mb-4"
        />
      ),
      text: "Store Settings",
      link: "/store-settings/info",
      className: "Store-Settings-for-android",
      dropdownItems: [
        // {
        //   id: 6,
        //   text: "Store",
        //   className: "flex items-center gap-2",
        //   dropDownItems: [
        //     // { id: 1, text: "Profile", link: "#" },
        //     { id: 61, text: "Info", link: "/store-settings/info" },
        //     { id: 62, text: "Setup", link: "/store-settings/setup" },
        //     {
        //       id: 63,
        //       icon: (
        //         <img
        //           src={CouponIcon}
        //           alt="option"
        //           className="h-6 w-10 mt-4 mb-4"
        //         />
        //       ),
        //       activeIcon: (
        //         <img src={CouIcon} alt="option" className="h-6 w-10 mt-4 mb-4 " />
        //       ),
        //       text: "Option",
        //       link: "/store-settings/options",
        //     },
        //   ],
        // },
        {
          id: 1728376800275,
          text: "Store Information",
          link: "/store-settings/info",
          className: "Store-Info-for-android",
        },
        {
          id: 1728376832601,
          icon: (
            <img src={CouponIcon} alt="option" className="h-6 w-10 mt-4 mb-4" />
          ),
          activeIcon: (
            <img src={CouIcon} alt="option" className="h-6 w-10 mt-4 mb-4 " />
          ),
          text: "Store Preferences",
          link: "/store-settings/options",
          className: "Store-Option-for-android",
        },
        {
          id: 1728376814838,
          text: "Online Store Settings",
          link: "/store-settings/setup",
          className: "Store-Setup-for-android",
        },
        {
          id: 68,
          text: "Inventory Preferences",
          link: "/store-settings/inventory",
          className: "Inventory-Settings-for-android",
        },
        {
          id: 64,
          icon: (
            <img
              src={CouponIcon}
              alt=" Alerts "
              className="h-6 w-10 mt-4 mb-4"
            />
          ),
          activeIcon: (
            <img src={CouIcon} alt=" Alerts " className="h-6 w-10 mt-4 mb-4 " />
          ),
          text: "Store Alerts",
          link: "/store-settings/Alters",
          className: "Alerts-for-android",
        },
        // { id: 65, text: "Taxes", link: "/store-settings/taxes" },

        // {
        //   id: 66,
        //   icon: (
        //     <img
        //       src={CouponIcon}
        //       alt="Add Employee"
        //       className="h-6 w-10 mt-4 mb-4"
        //     />
        //   ),
        //   activeIcon: (
        //     <img src={CouIcon} alt="option" className="h-6 w-10 mt-4 mb-4 " />
        //   ),
        //   text: "Manage Employees",
        //   link: "/store-settings/addemployee",
        // },
        // { id: 67, text: "Receipt", link: "/store-settings/receipt" },

        // { id: 69, text: "Register Settings", link: "/store-settings/register" },
        // { id: 70, text: "Quick Add", link: "/store-settings/quick-add" },
        {
          id: 71,
          text: "Report Scheduling",
          link: "/store-settings/system-access",
          className: "Reporting-Time-for-android",
        },
        ...(hasTobaccoScanProgramAccess
          ? [
            {
              id: 1739085600000,
              text: "Tobacco Scan Data (Beta)",
              link: `/store-settings/scan-data/${tobaccoScanLandingTab}`,
              className: "altriaform-for-android",
            },
          ]
          : []),
        // {
        //   id: 107,
        //   text: "Loyalty Program",
        //   link: "/store-settings/loyalty-program",
        // },
        {
          id: 1760519852866,
          text: "Breaks & Compliance",
          link: "/store-settings/breaks-and-compliance",
        },
        // Superadmin only while BULK_SETTINGS_SUPERADMIN_ONLY; after that owners,
        // and employees with "Bulk Update" (BULKS). Superadmin-only settings inside
        // the page stay hidden from everyone else by the API.
        ...(bulkSettingsVisibleFor(login_type, permissionsForMenuItems)
          ? [
            {
              id: 1791446400000,
              text: "Bulk Update",
              link: "/store-settings/bulk-update",
              ...(BULK_SETTINGS_SUPERADMIN_ONLY ? { className: "superadminGreen" } : {}),
            },
          ]
          : []),
        // ...(canSeeGroupManagementMenu
        //   ? [
        //       {
        //         id: 70,
        //         icon: (
        //           <img
        //             src={AttributesIcon}
        //             alt="create-group"
        //             className="h-6 w-10 mt-4 mb-4 hoverable-image"
        //           />
        //         ),
        //         activeIcon: (
        //           <img
        //             src={AtriIcon}
        //             alt="atributes"
        //             className="h-6 w-10 mt-4 mb-4"
        //           />
        //         ),
        //         text: "Group Management",
        //         link: "/store-settings/store-groups",
        //         className: "Create-Store-for-android",
        //       },
        //     ]
        //   : []),
      ],
    },
    {
      id: 9145693365,
      icon: (
        <img
          src={dataIcon}
          alt="Export Sold Items"
          className="h-6 w-10 mt-4 mb-4 hoverable-image"
        />
      ),
      activeIcon: (
        <img
          src={DataIconActive}
          alt="Import"
          className="h-6 w-10 mt-4 mb-4 "
        />
      ),
      text: "Import Data",
      link: "/import-data",
      className: "Import-Data-for-android",
      // className:
      //   LoginGetDashBoardRecordJson?.login_type === "superadmin"
      //     ? "superadminGreen"
      //     : "",
    },
    ...(!isMerchantBlockedFromExport ? [{
      id: 121246,
      icon: (
        <img
          src={InverntoryIcon}
          alt="labal"
          className="h-6 w-10 mt-4 mb-4 hoverable-image"
        />
      ),
      activeIcon: (
        <img
          src={InvertoryActive}
          alt="menu-defaults"
          className="h-6 w-10 mt-4 mb-4"
        />
      ),
      text: "Inventory Export",
      link: "/invertory-export",
      className: "Inventory-Export-for-android",
    }] : []),
    {
      id: 789,
      icon: (
        <img
          src={ASKAISVG}
          alt="Export Sold Items"
          className="h-6 w-10 mt-4 mb-4 hoverable-image"
        />
      ),
      activeIcon: (
        <img src={ASKAISVGY} alt="Import" className="h-6 w-10 mt-4 mb-4 " />
      ),
      text: "Ask QV-AI (Beta)",
      link: "/ask-quickvee-ai",
      className: " Ask-QV-AI-for-android",
    },
    {
      // Connectors: Zoho Connect, Quickvee HQ, Lumana Video and QuickBooks.
      // Each child keeps its own id and link, so the per-link access check on
      // click and the owner-only filter (idsToFilter) still apply to it.
      id: 224250,
      icon: (
        <span className="h-6 w-6 shrink-0 hoverable-image flex items-center justify-center">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M9 7V3.5M15 7V3.5" stroke="#7A7A7A" strokeWidth="1.7" strokeLinecap="round" />
            <path d="M6.5 7h11v3.5a5.5 5.5 0 01-11 0V7z" stroke="#7A7A7A" strokeWidth="1.7" strokeLinejoin="round" />
            <path d="M12 16v4.5" stroke="#7A7A7A" strokeWidth="1.7" strokeLinecap="round" />
          </svg>
        </span>
      ),
      activeIcon: (
        <span className="h-6 w-6 shrink-0 flex items-center justify-center">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M9 7V3.5M15 7V3.5" stroke="#0A64F9" strokeWidth="1.9" strokeLinecap="round" />
            <path d="M6.5 7h11v3.5a5.5 5.5 0 01-11 0V7z" stroke="#0A64F9" strokeWidth="1.9" strokeLinejoin="round" />
            <path d="M12 16v4.5" stroke="#0A64F9" strokeWidth="1.9" strokeLinecap="round" />
          </svg>
        </span>
      ),
      text: "Connector",
      className: "Connector-for-android",
      dropdownItems: [
        {
          id: 224245,
          // Submenu rows show submenuIcon (18px) in place of the bullet. Icons are
          // one colour (currentColor), so they follow the row's text colour like
          // the rest of the menu: grey, darker on hover, blue when active.
          submenuIcon: (
            <span
              className="qv-app-sidebar__submenu-mask"
              style={{ WebkitMaskImage: `url(${ZohoIcon})`, maskImage: `url(${ZohoIcon})` }}
            />
          ),
          text: "Zoho Connect",
          link: "/zoho-connect",
        },
        {
          // Quickvee HQ warehouse connector (owner-level, see idsToFilter).
          id: 224246,
          submenuIcon: (
            <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <rect x="2" y="9" width="7" height="7" rx="1.6" stroke="currentColor" strokeWidth="1.9" />
              <rect x="15" y="9" width="7" height="7" rx="1.6" stroke="currentColor" strokeWidth="1.9" />
              <path d="M9 12.5h6" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" />
            </svg>
          ),
          text: "Quickvee HQ",
          link: "/hq-connect",
        },
        ...(lumanaVisibleFor(login_type, permissionsForMenuItems)
          ? [
            {
              // Lumana Video is available to every signed-in user.
              id: 224252,
              submenuIcon: (
                <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M3 8.5A2.5 2.5 0 015.5 6h8A2.5 2.5 0 0116 8.5v7a2.5 2.5 0 01-2.5 2.5h-8A2.5 2.5 0 013 15.5v-7z" stroke="currentColor" strokeWidth="1.9" />
                  <path d="M16 10.5l4.2-2.4a.5.5 0 01.8.43v6.94a.5.5 0 01-.8.43L16 13.5" stroke="currentColor" strokeWidth="1.9" strokeLinejoin="round" />
                </svg>
              ),
              text: "Lumana Video",
              link: "/lumana-connect",
            },
          ]
          : []),
        {
          // QuickBooks Online, for every login. Connecting, mapping, and
          // posting are available to anyone who can open this store.
          id: 224248,
          // The QuickBooks mark (Assests/QuickBooks/qb-mark.svg) in one colour:
          // the circle is filled and the "qb" letters are cut out of it.
          submenuIcon: (
            <svg viewBox="0 0 18.09 18.09" aria-hidden="true">
              <path
                fill="currentColor"
                fillRule="evenodd"
                d="m9.04,18.09c4.99,0,9.04-4.05,9.04-9.04S14.04,0,9.04,0,0,4.05,0,9.04s4.05,9.04,9.04,9.04ZM2.53,9.04c0,1.91,1.56,3.44,3.5,3.44h.5v-1.28h-.5c-1.2,0-2.2-.98-2.2-2.16s1-2.16,2.2-2.16h1.2v6.68c0,.69.6,1.28,1.3,1.28V5.6h-2.51c-1.95,0-3.5,1.52-3.5,3.44h0Zm9.52-3.44h-.5v1.28h.5c1.2,0,2.2.98,2.2,2.16s-1,2.16-2.2,2.16h-1.2v-6.68c0-.69-.6-1.28-1.3-1.28v9.24h2.51c1.95,0,3.5-1.52,3.5-3.44s-1.56-3.44-3.5-3.44h0Z"
              />
            </svg>
          ),
          text: "QuickBooks",
          link: "/quickbooks",
        },
      ],
    },
    {
      id: 90005,
      icon: (
        <img
          src={AttributesIcon}
          alt="Audit Log"
          className="h-6 w-10 mt-4 mb-4 hoverable-image"
        />
      ),
      activeIcon: (
        <img src={AtriIcon} alt="Audit Log" className="h-6 w-10 mt-4 mb-4" />
      ),
      text: "Audit Log",
      link: "/audit-log",
      className: "AuditLog-for-android",
    },
    {
      id: 224247,
      icon: (
        <img
          src={TrainingIcon}
          alt="Training"
          className="h-6 w-10 mt-4 mb-4 hoverable-image"
        />
      ),
      activeIcon: (
        <img src={TrainingYIcon} alt="Training" className="h-6 w-10 mt-4 mb-4" />
      ),
      text: "Training",
      link: "/training",
      externalUrl: "https://training.quickvee.com/",
      alwaysNewTab: true,
    },
    // {
    //   id: 224246,
    //   icon: (
    //     <img
    //       src={Loyalty}
    //       alt="Order"
    //       className="h-6 w-10 mt-4 mb-4 hoverable-image"
    //     />
    //   ),
    //   activeIcon: <img src={Loyalty} alt="order" className="h-6 w-10 mt-4 mb-4" />,
    //   text: "Refer & Earn",
    //   // link: "/store-reporting/refer-and-earn",
    //   link: "/refer-and-earn",
    // },

    // {
    //   id: 10,
    //   icon: (
    //     <img
    //       src={dataIcon}
    //       alt="Import Data"
    //       className="h-6 w-10 mt-4 mb-4 hoverable-image"
    //     />
    //   ),
    //   activeIcon: (
    //     <img src={DataIconActive} alt="Import" className="h-6 w-10 mt-4 mb-4 " />
    //   ),
    //   text: "Import/Export",
    //   dropdownItems: [
    //     {
    //       id: 1,
    //       icon: (
    //         <img
    //           src={dataIcon}
    //           alt="Import Data"
    //           className="h-6 w-10 mt-4 mb-4 hoverable-image"
    //         />
    //       ),
    //       activeIcon: (
    //         <img
    //           src={DataIconActive}
    //           alt="Import"
    //           className="h-6 w-10 mt-4 mb-4 "
    //         />
    //       ),
    //       text: "Import Inventory",
    //       link: "#",
    //     },
    //     {
    //       id: 2,
    //       icon: (
    //         <img
    //           src={dataIcon}
    //           alt="Export Sold Items"
    //           className="h-6 w-10 mt-4 mb-4 hoverable-image"
    //         />
    //       ),
    //       activeIcon: (
    //         <img
    //           src={DataIconActive}
    //           alt="Import"
    //           className="h-6 w-10 mt-4 mb-4 "
    //         />
    //       ),
    //       text: "Export Sold Items",
    //       link: "/import-data",
    //     },
    //     // { id: 83, text: "Tip Report", link: "/store-reporting/tip-report" },
    //     // { id: 84, text: "Coupon Report", link: "/store-reporting/coupon-report" },
    //   ],
    // },
    // {
    //   id: 12,
    //   icon: (
    //     <img
    //       src={dataIcon}
    //       alt="Import Data"
    //       className="h-6 w-10 mt-4 mb-4 hoverable-image"
    //     />
    //   ),
    //   activeIcon: (
    //     <img src={DataIconActive} alt="Import" className="h-6 w-10 mt-4 mb-4 " />
    //   ),
    //   text: "Import Data",
    //   link: "/import-data",
    // },

    // {
    //   id: 91,
    //   icon: (
    //     <img
    //       src={dataIcon}
    //       alt="Export Sold Items"
    //       className="h-6 w-10 mt-4 mb-4 hoverable-image"
    //     />
    //   ),
    //   activeIcon: (
    //     <img src={DataIconActive} alt="Import" className="h-6 w-10 mt-4 mb-4 " />
    //   ),
    //   text: "Import Data",
    //   link: "/import-data",
    // },
  ];

  // const menuItems = useMemo(() => {
  //   console.log(
  //     "AllInSystemAccessState: ",
  //     AllInSystemAccessState,
  //     AllInSystemAccessState?.systemAccessData?.shift_assign === "1"
  //   );

  //   console.log("items: ", items);
  //   return items;
  // }, [AllInSystemAccessState]);

  // const { LoginGetDashBoardRecordJson, LoginAllStore, userTypeData } =
  //   useAuthDetails();

  // const ebtValue = AllInSystemAccessState?.systemAccessData?.ebt ?? "";
  // const ebtlastValue = ebtValue.split(",").pop();

  // console.log("AllInSystemAccessState", ebtlastValue);
  // console.log("LoginGetDashBoardRecordJson", LoginGetDashBoardRecordJson);
  // const ebt = LoginGetDashBoardRecordJson?.data?.ebt;
  // const ebt1 = console.log("ebt", ebt);

  const [menuItemSwitcher, setMenuItemSwitcher] = useState(menuItems);

  // useEffect(() => {
  //   // console.log("menuItemSwitcher: ", menuItemSwitcher)
  // }, [menuItemSwitcher])

  const temp = {
    superadmin: menuItemSwitcher,
    admin: merchant,
    manager: ManagerLink,
    merchant: MerchantLink,
  };
  const currentMenuItems = (
    LoginGetDashBoardRecordJson?.final_login == 1
      ? temp["superadmin"]
      : temp[LoginGetDashBoardRecordJson?.data?.login_type]
  );

  const location = useLocation();
  const currentUrl = location.pathname;
  const store = useStore();

  // Do NOT subscribe to Redux isDropdownOpen — that re-rendered the full menu
  // on every accordion open. Open section is local `currentDropDownItem` only.
  const isStoreActive = useSelector(
    (state) => state.NavBarToggle.isStoreActive,
  );

  const menuLinks = useMemo(
    () => collectMenuLinks(currentMenuItems),
    [currentMenuItems],
  );
  const [activeItem, setActiveItem] = useState(() =>
    resolveActiveMenuPath(currentUrl, menuLinks),
  );
  const [hoveredItem, setHoveredItem] = useState(null);
  const [currentDropDownItem, activeDropDownItem] = useState(null);
  const [activeNestedItem, setActiveNestedItem] = useState();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isTabletNav = useMediaQuery("(max-width:1024px)");
  const isMobileNavtest = useMediaQuery("(max-width: 768px)");

  const getMenuOpen = () => store.getState().NavBarToggle.isMenuOpen;
  const getOpenedByHover = () => store.getState().NavBarToggle.isOpenedByHover;

  const isNewTabIntent = (event) => {
    return (
      !!event &&
      (event.ctrlKey || event.metaKey || event.shiftKey || event.button === 1)
    );
  };

  const isModifiedNavigationEvent = (event) =>
    Boolean(
      event &&
      (event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey ||
        event.button === 1),
    );

  const closeSideMenuOnMobile = () => {
    // Header hamburger also flips isMobileViewActive on desktop, so only
    // use the viewport breakpoint — never collapse the desktop sidebar.
    if (!isTabletNav) return;
    dispatch(setIsDropdownOpen(false));
    dispatch(setMenuOpen(false));
    dispatch(setIsMobileViewActive(false));
    setHoveredItem(null);
  };

  const handleItemClick = (item, event) => {
    if (item.externalUrl) {
      event?.preventDefault?.();
      window.open(item.externalUrl, "_blank", "noopener,noreferrer");
      // External / new-tab links leave the app — still close the mobile drawer.
      closeSideMenuOnMobile();
      return;
    }
    // Lottery is always shown but only accessible when the EBT flag === 4;
    // otherwise it falls through the same "Access Denied" flow as other items.
    const lotteryBlocked =
      item.link === "/inventory/lottery" && !isLotteryAccessible;
    if (lotteryBlocked || !canAccessMenuLink(item.link, isStoreActive)) {
      // ToastifyAlert("You do not have permission to access this page", "error");
      event?.preventDefault?.();
      ToastifyAlert("Access Denied", "error");
      if (isNewTabIntent(event)) {
        // navigate(item.link, { replace: true });
        window.open('/merchants' + item.link, "_blank");
      }
      return;
    }
    if (item.alwaysNewTab) {
      event?.preventDefault?.();
      window.open('/merchants' + item.link, "_blank");
      closeSideMenuOnMobile();
      return;
    }
    if (isNewTabIntent(event)) {
      // window.open('/merchants' + item.link, "_blank");
      // navigate(item.link, { replace: true });
      return;
    }
    if (isTabletNav) {

      // console.log("inside handleItemClick isTabletNav");
      dispatch(setIsDropdownOpen(false));
      dispatch(setMenuOpen(false));
      dispatch(setIsMobileViewActive(false));
      setHoveredItem(null);
    }
    if (getOpenedByHover()) {
      dispatch(setIsDropdownOpen(false));
      dispatch(setMenuOpen(false));
      dispatch(setIsMobileViewActive(false));
      setHoveredItem(null);
    }
    setActiveItem(item.link);
    navigate(item.link);
    setActiveNestedItem(null);
    // dispatch(setIsDropdownOpen(false))
    activeDropDownItem(null);
    // dispatch(setIsMobileViewActive(false))
  };

  // console.log("active item", activeItem)

  // useEffect(() => {
  //   dispatch(setMenuOpen(!isTabletNav));
  //   dispatch(setIsMobileViewActive(false));
  // }, [isTabletNav, isMobileNav]);

  const fetchPermissionAPI = () => {
    const emp_id = window.localStorage.getItem("emp_id");
    if (emp_id !== null && emp_id !== undefined) {
      const requestData = { emp_id: emp_id };
      dispatch(fetchPermissions(requestData));
    }
  };
  const checkelasticConnection = () => {
    dispatch(CheckElasticConnection());
  };

  useEffect(() => {
    fetchPermissionAPI();
    checkelasticConnection();
  }, [dispatch]);

  const { permissions, status, error } = useSelector(
    (state) => state.permissions,
  );

  useEffect(() => {
    // Set the menu open state based on screen width (tablet or mobile view)
    // But also don't override the user manually toggling the menu
    if (isTabletNav) {
      dispatch(setMenuOpen(false)); // Open the menu for smaller screens
      dispatch(setIsDropdownOpen(false));
    }
    dispatch(setIsMobileViewActive(false));
  }, [isTabletNav, dispatch]);
  // ==================================
  const obj = {};
  // =================================
  const permissionMap = useMemo(
    () => ({
      // Customers: PERMISSIONS.ACCESS_CUSTOMER,
      "Customer Management": PERMISSIONS.ACCESS_CUSTOMER,
      Employees: PERMISSIONS.MENU_ACCESS_EMPLOYEES,
      Inventory: PERMISSIONS.MENU_ACCESS_INVENTORY,
      "Stock on Hand": PERMISSIONS.MENU_ACCESS_STOCK_ON_HAND,
      Reporting: PERMISSIONS.MENU_ACCESS_REPORTS,
      // "Store Settings": PERMISSIONS.MENU_SYSTEM_ACCESS,
      "Loyalty Program": PERMISSIONS.MENU_ACCESS_LOYALTY_PROGRAM,
      "Old Vendors": PERMISSIONS.MENU_ACCESS_VENDORS,
      Vendors: PERMISSIONS.MENU_ACCESS_VENDORS,
      Customer: PERMISSIONS.MENU_CUSTOMERS_HOME_SCREEN,
      "Purchase Order": PERMISSIONS.MENU_ACCESS_PURCHASE_ORDERS,
      Stocktake: PERMISSIONS.MENU_ACCESS_STOCKTAKE,
      "Old Stocktake": PERMISSIONS.MENU_ACCESS_STOCKTAKE,
      "Stocktake (demo)": PERMISSIONS.MENU_ACCESS_STOCKTAKE,
      Coupons: PERMISSIONS.MENU_ACCESS_COUPONS,
      Orders: PERMISSIONS.MENU_ORDERS_HOME_SCREEN,
      Taxes: PERMISSIONS.MENU_ACCESS_TAXES,
      "Mix N' Match Pricing": PERMISSIONS.MENU_ACCESS_MIX_N_MATCH,
      "Store Settings": PERMISSIONS.MENU_ACCESS_STORE_SETTINGS,
      Promotions: PERMISSIONS.MENU_COUPON,
      // Promotions: PERMISSIONS.MENU_ACCESS_MIX_N_MATCH,

      // //  Promotions: {
      //   Coupons: PERMISSIONS.MENU_COUPON,
      //   "Mix N' Match Pricing": PERMISSIONS.MENU_ACCESS_MIX_N_MATCH,
      // },
      "Ask QV-AI (Beta)": PERMISSIONS.ACCESS_AI,
      "Audit Log": PERMISSIONS.MENU_AUDIT_LOG,
    }),
    [],
  );
  const submenuPermissionMap = useMemo(
    () => ({
      Reporting: {
        Sales: PERMISSIONS.MENU_SALES_REPORTS,
        Inventory: PERMISSIONS.MENU_INVENTORY_REPORTS,
        Customers: PERMISSIONS.MENU_CUSTOMER_REPORTS,
        Employees: PERMISSIONS.MENU_EMPLOYEE_REPORTS,
        Payments: PERMISSIONS.MENU_PAYMENT_REPORTS,
        "Register Activity": PERMISSIONS.MENU_REGISTER_ACTIVITY_REPORTS,
        Refunds: PERMISSIONS.MENU_REFUND_REPORTS,
        Loyalty: PERMISSIONS.MENU_LOYALTY_REPORT,
        "Store Credit": PERMISSIONS.MENU_STORE_CREDIT_REPORTS,
        "Gift Cards": PERMISSIONS.MENU_GIFT_CARD_REPORTS,
        Taxes: PERMISSIONS.MENU_TAX_REPORTS,
        "Location Report": PERMISSIONS.MENU_LOCATION_REPORTS,
        "Item Sold Report": PERMISSIONS.MENU_ITEM_SOLD_REPORT,
        "Category Sold Report": PERMISSIONS.MENU_CATEGORY_SOLD_REPORT,
        "PO Products Report": PERMISSIONS.MENU_PO_PRODUCTS_REPORT,

      },
      Inventory: {
        "Old Categories": PERMISSIONS.MENU_MANAGE_CATEGORIES,
        Products: PERMISSIONS.MENU_MANAGE_PRODUCTS,
        "Bulk Updates": PERMISSIONS.MENU_BULK_PRODUCT_UPDATE,
        "Store transfer": PERMISSIONS.MENU_MANAGE_PRODUCTS,
        // Composite items have their own permission code, COITM.
        "Composite Items": PERMISSIONS.MENU_COMPOSITE_ITEMS,
        "Container Deposit": PERMISSIONS.MENU_CONTAINER_DEPOSIT,
        "Old Attributes": PERMISSIONS.MENU_MANAGE_ATTRIBUTES,
        "Old Brands": PERMISSIONS.MENU_MANAGE_BRANDS,
        "Old Tags": PERMISSIONS.MENU_MANAGE_TAGS,
        Lottery: PERMISSIONS.MENU_LOTTERY,
        // New-UI siblings reuse the same per-entity permissions as the old
        // menus — if an employee can manage categories, they can use the
        // new categories screen too.
        Categories: PERMISSIONS.MENU_MANAGE_CATEGORIES,
        Brands: PERMISSIONS.MENU_MANAGE_BRANDS,
        "Attributes": PERMISSIONS.MENU_MANAGE_ATTRIBUTES,
        Tags: PERMISSIONS.MENU_MANAGE_TAGS,
        "New Products": PERMISSIONS.MENU_MANAGE_PRODUCTS,
        "Old Vendors": PERMISSIONS.MENU_ACCESS_VENDORS,
        Vendors: PERMISSIONS.MENU_ACCESS_VENDORS,
        Packaging: PERMISSIONS.MENU_MANAGE_PRODUCTS,
      },
      // Same codes these four used as top-level items / under Inventory.
      "Stock Control": {
        "Stock on Hand": PERMISSIONS.MENU_ACCESS_STOCK_ON_HAND,
        "Purchase Order": PERMISSIONS.MENU_ACCESS_PURCHASE_ORDERS,
        Stocktake: PERMISSIONS.MENU_ACCESS_STOCKTAKE,
        Transfers: PERMISSIONS.MENU_ACCESS_INVENTORY_TRANSFER,
      },
      Employees: {
        "Manage Employees": PERMISSIONS.MENU_MANAGE_EMPLOYEES,
        Timesheet: PERMISSIONS.MENU_TIMESHEET,
        "New Timesheet": PERMISSIONS.MENU_TIMESHEET,
      },
      Promotions: {
        Coupons: PERMISSIONS.MENU_COUPON,
        "Mix N' Match Pricing": PERMISSIONS.MENU_ACCESS_MIX_N_MATCH,
        "BOGO Pricing": PERMISSIONS.MENU_ACCESS_BOGO,
        // CUFEE, its own code — an employee who can edit coupons has no business
        // publishing to customers by default. The parent filter below keeps
        // Promotions visible for anyone holding a submenu code, so CUFEE alone
        // is enough to reach this entry.
        "Customer Feed": PERMISSIONS.ACCESS_CUSTOMER_FEED,
        "Gift Card": PERMISSIONS.MENU_GIFT_CARD,
      },
      "Store Settings": {
        "Store Information": PERMISSIONS.MENU_STORE_INFO,
        "Online Store Settings": PERMISSIONS.MENU_ONLINE_STORE_SETUP,
        "Store Preferences": PERMISSIONS.MENU_STORE_OPTIONS,
        "Store Alerts": PERMISSIONS.MENU_ALERTS,
        "Inventory Preferences": PERMISSIONS.MENU_INVENTORY_SETTINGS,
        "Report Scheduling": PERMISSIONS.MENU_REPORTING_TIME,
        "Register Preferences": PERMISSIONS.MENU_REGISTER_SETTINGS,
        "Group Management": PERMISSIONS.MENU_ACCESS_GROUP_MANAGEMENT,
        "Bulk Update": PERMISSIONS.MENU_BULK_STORE_SETTINGS,
      },
    }),
    [],
  );
  const newMenu = [];
  // Kept apart from the menu-building effect below: that effect updates
  // menuItemSwitcher, which feeds menuLinks, so sharing deps would loop.
  useEffect(() => {
    setActiveItem(resolveActiveMenuPath(currentUrl, menuLinks));
  }, [currentUrl, menuLinks]);

  useEffect(() => {
    // if (currentUrl.split("/")[1] === "users") {
    //   setMenuItemSwitcher(SuperAdminMenuItems);
    //   dispatch(setMenuOpen(true));
    // } else {
    //   setMenuItemSwitcher(menuItems);
    // }
    // console.log("setIsStoreActive setIsStoreActive0,",isStoreActive)
    if (!isStoreActive) {
      setMenuItemSwitcher(SuperAdminMenuItems);
      // dispatch(setMenuOpen(true));
    } else {
      // alert('here')
      // permission_code
      let updatedMenuItems = [];
      // add id's here to show only for superadmin
      const idsToFilter = [224246]; // Quickvee HQ — merchant/superadmin/admin only, not employees (Lumana Video decides by permission)
      const is_zoho_enable = LoginGetDashBoardRecordJson?.data?.zoho_enable;
      const is_superadmin_login = LoginGetDashBoardRecordJson?.login_type;
      // let permission = window.localStorage.getItem('permissions');
      // if(LoginGetDashBoardRecordJson?.login_type != "merchant" && LoginGetDashBoardRecordJson?.login_type != "superadmin" && LoginGetDashBoardRecordJson?.login_type != "admin" && permissions){
      //   const newMenu = menuItems.filter(item => {
      //     const requiredPermission = permissionMap[item.text];
      //     return  requiredPermission && permissions.includes(requiredPermission);
      //   });
      //   updatedMenuItems =[...newMenu]

      // }
      // console.log("menuItems: ", menuItems)
      //   console.log("permissionMap: ", permissionMap)
      //   console.log("submenuPermissionMap: ", submenuPermissionMap)
      //   console.log("permissions: ", permissions)
      if (
        LoginGetDashBoardRecordJson?.login_type !== "merchant" &&
        LoginGetDashBoardRecordJson?.login_type !== "superadmin" &&
        LoginGetDashBoardRecordJson?.login_type !== "admin" &&
        permissions
      ) {
        let withoutZoho = [];

        // const index = menuItems.findIndex((item) => item.id === 224245);
        // if (index !== -1) {
        //  menuItems.splice(index, 1); // Remove the item at the found index
        withoutZoho = menuItems
          .filter((item) => !idsToFilter.includes(item.id))
          .map((item) =>
            item.dropdownItems
              ? { ...item, dropdownItems: item.dropdownItems.filter((sub) => !idsToFilter.includes(sub.id)) }
              : item,
          );
        // }
        // const newMenu = withoutZoho
        //   .map((item) => {
        //     const requiredPermission = permissionMap[item.text];
        //     // console.log("item text: ",item.text)
        //     // console.log("requiredPermission: ", requiredPermission)
        //     // console.log("condition 1: ",
        //     //   Boolean(requiredPermission) && !permissions.includes(requiredPermission),
        //     //   !permissions.includes(requiredPermission))
        //     if (
        //       requiredPermission &&
        //       !permissions.includes(requiredPermission || checkInclusion(permissions, submenuPermissions[submenu.text] ))
        //     ) {
        //       return null;
        //     }
        //     const submenuPermissions = submenuPermissionMap[item.text] || {};
        //     console.log("submenuPermissions", submenuPermissions);
        //     // console.log("submenuPermissions: ", submenuPermissions)
        //     const updatedDropdownItems = item.dropdownItems?.filter(
        //       (submenu) => {
        //         const submenuPermission = submenuPermissions[submenu.text];
        //         return (
        //           submenuPermission && permissions.includes(submenuPermission)
        //         );
        //       }
        //     );
        //     // console.log("updatedDropdownItems: ", updatedDropdownItems)
        //     return {
        //       ...item,
        //       dropdownItems: updatedDropdownItems,
        //     };
        //   })
        const newMenu = withoutZoho
          .map((item) => {
            const requiredPermission = permissionMap[item.text];
            const submenuPermissions = submenuPermissionMap[item.text] || {};

            // Skip the menu if requiredPermission exists and user lacks both it and all submenu permissions
            const hasMenuPermission = hasMenuItemPermission(
              item.text,
              permissions,
              requiredPermission,
            );
            const hasAnySubmenuPermission = Object.values(
              submenuPermissions,
            ).some((p) => permissions.includes(p));

            if (
              requiredPermission &&
              !hasMenuPermission &&
              !hasAnySubmenuPermission
            ) {
              return null;
            }

            const updatedDropdownItems = item.dropdownItems?.filter(
              (submenu) => {
                if (
                  submenu.text === "Group Management" &&
                  !canSeeGroupManagementMenu
                ) {
                  return false;
                }
                const submenuPermission = submenuPermissions[submenu.text];
                return (
                  submenuPermission && permissions.includes(submenuPermission)
                );
              },
            );
            return {
              ...item,
              dropdownItems: updatedDropdownItems,
            };
          })
          .filter(Boolean);

        // const AskQuickveeAI = {
        //   id: 789,
        //   icon: (
        //     <img
        //       src={ASKAISVG}
        //       alt="Export Sold Items"
        //       className="h-6 w-10 mt-4 mb-4 hoverable-image"
        //     />
        //   ),
        //   activeIcon: (
        //     <img
        //       src={ASKAISVGY}
        //       alt="Import"
        //       className="h-6 w-10 mt-4 mb-4 "
        //     />
        //   ),
        //   text: "Ask QV-AI (Beta)",
        //   link: "/ask-quickvee-ai",
        //   className: " Ask-QV-AI-for-android",
        // };
        // console.log("newMenu",newMenu)
        // console.log("permissions",permissions)
        updatedMenuItems = [...newMenu];
        const hasAccessAIMerchant = permissions.length && permissions.includes(PERMISSIONS.ACCESS_AI);
        if (hasAccessAIMerchant) {
          updatedMenuItems.splice(updatedMenuItems.length - 1, 0,
            // AskQuickveeAI
          );
        }
        // setMenuItemSwitcher(updatedMenuItems);
        // for access denied showing all menu items but not clickable
        setMenuItemSwitcher(menuItems);
      } else if (is_superadmin_login == "merchant") {
        // const newCreateGroup = {
        //   id: 70,
        //   icon: (
        //     <img
        //       src={AttributesIcon}
        //       alt="create-group"
        //       className="h-6 w-10 mt-4 mb-4 hoverable-image"
        //     />
        //   ),
        //   activeIcon: (
        //     <img
        //       src={AtriIcon}
        //       alt="atributes"
        //       className="h-6 w-10 mt-4 mb-4"
        //     />
        //   ),
        //   text: "Create Group",
        //   link: "/store-settings/store-groups",
        //   // link: "/store-settings/create-group",
        //   className: "Create-Store-for-android",
        // };
        // let updatedMenuItems = [...menuItems];
        // if (moreThanOneStoreAvailable) {
        //   updatedMenuItems = updatedMenuItems?.map((item) => {
        //     if (item.id === 10 && item.dropdownItems) {
        //       return {
        //         ...item,
        //         dropdownItems: [
        //           ...item.dropdownItems,
        //           newCreateGroup,
        //           // newregistersetting,
        //           // newMenuItemDigit,
        //         ],
        //       };
        //     }
        //     return item;
        //   });
        // }
        // if (is_zoho_enable == 0) {
        //   // const index = menuItems.findIndex((item) => item.id === 224245);
        //   // if (index !== -1) {
        //   // menuItems.splice(index, 1); // Remove the item at the found index
        //   updatedMenuItems = updatedMenuItems.filter(
        //     (item) => !idsToFilter.includes(item.id)
        //   );
        //   // }
        //   // updatedMenuItems = [...withoutZoho];
        //   setMenuItemSwitcher(updatedMenuItems);
        // }
        // const AskQuickveeAI = {
        //   id: 789,
        //   icon: (
        //     <img
        //       src={ASKAISVG}
        //       alt="Export Sold Items"
        //       className="h-6 w-10 mt-4 mb-4 hoverable-image"
        //     />
        //   ),
        //   activeIcon: (
        //     <img
        //       src={ASKAISVGY}
        //       alt="Import"
        //       className="h-6 w-10 mt-4 mb-4 "
        //     />
        //   ),
        //   text: "Ask QV-AI (Beta)",
        //   link: "/ask-quickvee-ai",
        //   className: " Ask-QV-AI-for-android",
        // };
        const ALLOW_MerchantsAI = [
          "PRA0351CA",
          "SAM0380CA",
          "AMM6809CA",
          "SHA71729TX",
          "ANI178107TX",
          "ALI89014TX",
          "MOH94158TX",
          "JOS9344OH",
          "OSA238752MO",
          "BAS82829FL",
          "FAW29198NJ",
          "VIV102927MA",
          "VAR269017CA",
          "CHA200570AP",
        ];

        // if (ALLOW_MerchantsAI?.includes(merchant_id)) {
        menuItems.splice(menuItems.length - 1, 0,
          // AskQuickveeAI
        );
        // }
      }
      updatedMenuItems = [...menuItems];

      if (LoginGetDashBoardRecordJson?.login_type === "merchant") {
        // Always show Lottery; access is gated on click by the EBT flag
        // (see handleItemClick), so it never disappears from the menu.
        const showLottery = true;

        updatedMenuItems = updatedMenuItems.map((item) => {
          if (item.id !== 4 || !item.dropdownItems) return item;

          // The base list already carries Lottery and Bulk Updates in the
          // order the user set (2026-08-31) — re-appending them here pushed
          // both past Transfers/Audit Log. Only drop what this view hides.
          const dropdownItems = item.dropdownItems.filter(
            (sub) =>
              sub.link !== "/inventory-merge" &&
              (showLottery || sub.id !== 1726725862759),
          );

          return { ...item, dropdownItems };
        });

        setMenuItemSwitcher(updatedMenuItems);
      }

      // let newMenu = [];
      // for(let i =0; i<menuItems.length; i++ ){
      //   if(menuItems[i].text == "Employees" &&  permission.includes("AE")){
      //     newMenu.push(menuItems[i])
      //   }else  if(menuItems[i].text == "Inventory" &&  permission.includes("AI")){
      //     newMenu.push(menuItems[i])
      //   }else  if(menuItems[i].text == "Reporting" &&  permission.includes("AR")){
      //     newMenu.push(menuItems[i])
      //   }else  if(menuItems[i].text == "Store Setting" &&  permission.includes("SY")){
      //     newMenu.push(menuItems[i])
      //   }else  if(menuItems[i].text == "Loyalty Program" &&  permission.includes("ALP")){
      //     newMenu.push(menuItems[i])
      //   }else  if(menuItems[i].text == "Vendor" &&  permission.includes("AV")){
      //     newMenu.push(menuItems[i])
      //   }else  if(menuItems[i].text == "Purchase Orders" &&  permission.includes("AP")){
      //     newMenu.push(menuItems[i])
      //   }else  if(menuItems[i].text == "Stocktake" &&  permission.includes("AK")){
      //     newMenu.push(menuItems[i])
      //   }else  if(menuItems[i].text == "Coupons" &&  permission.includes("AC")){
      //     newMenu.push(menuItems[i])
      //   }else  if(menuItems[i].text == "Taxes" &&  permission.includes("T")){
      //     newMenu.push(menuItems[i])
      //   }

      // }

      // menuItems = menuItems.filter((item)=>{
      //   return item.text == "Employees" && permission.includes("AI");
      //   // if(item.text == "Employees" && permission.includes("AI") ){

      //   // }
      // })

      if (LoginGetDashBoardRecordJson?.login_type === "superadmin") {
        // console.log("LoginGetDashBoardRecordJson?.login_type === superadmin");
        const newMenuItem = {
          id: 9112345741,
          icon: (
            <img
              src={dataIcon}
              alt="Export Sold Items"
              className="h-6 w-10 mt-4 mb-4 hoverable-image"
            />
          ),
          activeIcon: (
            <img
              src={DataIconActive}
              alt="Import"
              className="h-6 w-10 mt-4 mb-4 "
            />
          ),
          text: "Import Data",
          link: "/import-data",
          className: "superadminGreen",
        };
        const AskQuickveeAI = {
          id: 789,
          icon: (
            <img
              src={ASKAISVG}
              alt="Export Sold Items"
              className="h-6 w-10 mt-4 mb-4 hoverable-image"
            />
          ),
          activeIcon: (
            <img src={ASKAISVGY} alt="Import" className="h-6 w-10 mt-4 mb-4 " />
          ),
          text: "Ask QV-AI (Beta)",
          link: "/ask-quickvee-ai",
          className: " Ask-QV-AI-for-android",
        };
        const mixedAndMatch = {
          id: 9,
          icon: (
            <img
              src={MixMatchIcon}
              alt="mix-match-icon"
              className="h-6 w-10 mt-4 mb-4"
            />
          ),
          activeIcon: (
            <img
              src={MixMatchIcon1}
              alt="mix-match-icon-1"
              className="h-6 w-10 mt-4 mb-4 "
            />
          ),
          text: "Mix N' Match Pricing",
          link: "/promotions/mix-and-match",
          className:
            "Mix-And-Match-Pricing-for-android Mix-N'-Match-Pricing-for-android superadminGreen",
        };

        const BogoPricing = {
          id: 10,
          icon: (
            <img
              src={MixMatchIcon}
              alt="bogo-pricing-icon"
              className="h-6 w-10 mt-4 mb-4"
            />
          ),
          activeIcon: (
            <img
              src={MixMatchIcon1}
              alt="bogo-pricing-icon-1"
              className="h-6 w-10 mt-4 mb-4 "
            />
          ),
          text: "Bogo Pricing",
          link: "/promotions/bogo-pricing",
          className:
            "Mix-And-Match-Pricing-for-android Mix-N'-Match-Pricing-for-android superadminGreen",
        };

        const ZohoMenuItem = {
          id: 224245,
          icon: (
            <img
              src={ZohoIcon}
              alt="Order"
              className="h-6 w-10 mt-4 mb-4 hoverable-image"
            />
          ),
          activeIcon: (
            <img src={ZohoYIcon} alt="order" className="h-6 w-10 mt-4 mb-4" />
          ),
          text: "Zoho Connect",
          link: "/zoho-connect",
          className: "superadminGreen",
        };
        // updatedMenuItems.splice(updatedMenuItems.length - 4, 0, mixedAndMatch);
        // updatedMenuItems.push(ZohoMenuItem);
        // updatedMenuItems.splice(updatedMenuItems.length - 11, 0, ZohoMenuItem);
        // updatedMenuItems.splice(updatedMenuItems.length - 1, 0, newMenuItem);
        updatedMenuItems.splice(updatedMenuItems.length - 1, 0,
          // AskQuickveeAI
        );

        const newMenuItemDigit = {
          id: 92,
          icon: (
            <img
              src={dataIcon}
              alt="MainDigitalMarketing"
              className="h-6 w-10 mt-4 mb-4 hoverable-image"
            />
          ),
          activeIcon: (
            <img
              src={DataIconActive}
              alt="MainDigitalMarketing"
              className="h-6 w-10 mt-4 mb-4"
            />
          ),
          text: "Marketing Tags",
          link: "/Digital-marketing-tags",
          className: "superadminGreen",
        };
        const newregistersetting = {
          id: 69,
          icon: (
            <img
              src={AttributesIcon}
              alt="inventory-merge"
              className="h-6 w-10 mt-4 mb-4 hoverable-image"
            />
          ),
          activeIcon: (
            <img
              src={AtriIcon}
              alt="atributes"
              className="h-6 w-10 mt-4 mb-4"
            />
          ),
          text: "Register Preferences",
          link: "/store-settings/register",
          className: "superadminGreen",
        };
        const newCreateGroup = {
          id: 70,
          icon: (
            <img
              src={AttributesIcon}
              alt="create-group"
              className="h-6 w-10 mt-4 mb-4 hoverable-image"
            />
          ),
          activeIcon: (
            <img
              src={AtriIcon}
              alt="atributes"
              className="h-6 w-10 mt-4 mb-4"
            />
          ),
          text: "Create Group",
          link: "/customer-management/customer-groups",
          className: "superadminGreen",
        };
        // const isLottery = "0";
        const newUpdateInventoryMerge = [
          // ...(isLottery === "0"
          //   ? [
          //       {
          //         id: 1726725862759,
          //         icon: (
          //           <img
          //             src={AttributesIcon}
          //             alt="Lottery"
          //             className="h-6 w-10 mt-4 mb-4 hoverable-image"
          //           />
          //         ),
          //         activeIcon: (
          //           <img
          //             src={AtriIcon}
          //             alt="Lottery"
          //             className="h-6 w-10 mt-4 mb-4"
          //           />
          //         ),
          //         text: "Lottery",
          //         link: "/inventory/lottery",
          //       },
          //     ]
          //   : []),
          {
            id: 15,
            icon: (
              <img
                src={AttributesIcon}
                alt="inventory-merge"
                className="h-6 w-10 mt-4 mb-4 hoverable-image"
              />
            ),
            activeIcon: (
              <img
                src={AtriIcon}
                alt="atributes"
                className="h-6 w-10 mt-4 mb-4"
              />
            ),
            text: "Merge Inventory",
            link: "/inventory-merge",
            className: "superadminGreen",
          },
          // Keep Bulk Updates last in Inventory (after Merge Inventory).
          bulkUpdatesMenuItem,
        ];
        const updatedReportingForSuperAdmin = [
          // {
          //   id: 3,
          //   text: "Employee Reports",
          //   dropDownItems: [
          //     {
          //       id: 72,
          //       text: "Employee List",
          //       link: "/store-reporting/employee-list",
          //     },
          //     {
          //       id: 75,
          //       text: "Employee Working Hours",
          //       link: "/store-reporting/employee-working-hours",
          //     },
          //     {
          //       id: 89,
          //       text: "Discount Per Sales Person",
          //       link: "/store-reporting/discount-per-sales-report",
          //     },
          //   ],
          // },
          // {
          //   id: 1723011716338,
          //   text: "Customer Reports",
          //   dropDownItems: [
          //     {
          //       id: 103,
          //       text: "New Customers Added Report",
          //       link: "/store-reporting/new-customers-added-report",
          //     },
          //     // {
          //     //   id: 101,
          //     //   text: "Detailed Loyalty Points Report",
          //     //   link: "/store-reporting/detailed-loyalty-points-report",
          //     // },
          //   ],
          // },
          // {
          //   id: 5,
          //   text: "Vendors",
          //   dropDownItems: [
          //     {
          //       id: 71,
          //       text: "Vendors List",
          //       link: "/store-reporting/vendors-list",
          //     },
          //     {
          //       id: 86,
          //       text: "Vendors Payout",
          //       link: "/store-reporting/vendors-sales-reports",
          //     },
          //   ],
          // },
          {
            id: 86,
            text: "Vendors Payout",
            link: "/store-reporting/vendors-sales-reports",
          },
          // {
          //   id: 115,
          //   text: "Lottery Payout Report",
          //   link: "/store-reporting/lottery-payout-report",
          // },
        ];
        const updatedTest = updatedMenuItems.map((item) => {
          if (item.id === 123456 && item.dropdownItems) {
            return {
              ...item,
              dropdownItems: [
                ...item.dropdownItems,
                // BogoPricing,
                // mixedAndMatch,
              ],
            };
          }
          if (item.id === 10 && item.dropdownItems) {
            return {
              ...item,
              dropdownItems: [
                ...item.dropdownItems.slice(0, 4),
                // newCreateGroup,
                newregistersetting,
                ...item.dropdownItems.slice(4),
                newMenuItemDigit,
              ],
            };
          }

          if (item.id === 4 && item.dropdownItems) {
            // Superadmin-only Merge Inventory slots in just before Bulk
            // Updates; appending the whole pair used to drag Bulk Updates
            // behind Transfers/Audit Log and break the user's ordering.
            const mergeOnly = newUpdateInventoryMerge.filter(
              (sub) => sub?.link === "/inventory-merge",
            );
            const dropdownItems = [...item.dropdownItems];
            const at = dropdownItems.findIndex(
              (sub) => sub?.link === "/inventory/bulk-product-update",
            );
            dropdownItems.splice(at === -1 ? dropdownItems.length : at, 0, ...mergeOnly);
            return { ...item, dropdownItems };
          }
          // if (item.id === 3 && item.dropdownItems) {
          //   // const issuedLoyaltyProgram = {
          //   //   id: 1729596404509111,
          //   //   text: "Issued Loyalty Program",
          //   //   link: "/store-reporting/loyalty-program",
          //   // };
          //   const oldSalesSummeryReport ={
          //     id: 1729596404509111212121212,
          //       text: "Old Salse Summery",
          //       link: "/store-reporting/old-sales-summery",
          //   }
          //   const newDropdownItems = [...item.dropdownItems];
          //   // newDropdownItems.splice(8, 0, issuedLoyaltyProgram);
          //   newDropdownItems.splice(1, 0, oldSalesSummeryReport);
          //   return {
          //     ...item,
          //     dropdownItems: [
          //       ...newDropdownItems,
          //       // ...updatedReportingForSuperAdmin,
          //     ],
          //   };
          // }
          return item;
        });
        // console.log("test", updatedTest);
        setMenuItemSwitcher(updatedTest);
      }
    }
  }, [
    currentUrl,
    isStoreActive,
    permissions,
    SuperAdminMenuItems,
    // menuItems,
    permissionMap,
    isLotteryAccessible,
    moreThanOneStoreAvailable,
    login_type,
    canSeeGroupManagementMenu,
  ]);


  // if assign_shift
  // useEffect(() => {
  //   if(isStoreActive){
  //     const obj = {
  //       id: 1726123837135,
  //       text: "Register Activity",
  //       link: `/store-reporting/register-activity/${
  //         !AllInSystemAccessState?.loading &&
  //         AllInSystemAccessState?.systemAccessData &&
  //         AllInSystemAccessState?.systemAccessData?.shift_assign !== "1"
  //           ? "register-closures"
  //           : "drop-cash"
  //       }`,
  //       className: "Register-Activity-for-android",
  //     };

  //     const newItems = menuItems.map((item) => {
  //       if (item.text === "Reporting") {
  //         const updatedDropdownItems =
  //           item.dropdownItems &&
  //           item.dropdownItems.map((report) =>
  //             report.id === obj.id ? obj : report
  //           );
  //         return { ...item, dropdownItems: updatedDropdownItems };
  //       } else {
  //         return item;
  //       }
  //     });
  //     setMenuItemSwitcher(() => newItems);
  //   }
  // }, [AllInSystemAccessState]);

  // useEffect(() => {
  //   if (LoginGetDashBoardRecordJson?.login_type === "merchant") {
  //     const newCreateGroup = {
  //       id: 70,
  //       icon: (
  //         <img
  //           src={AttributesIcon}
  //           alt="create-group"
  //           className="h-6 w-10 mt-4 mb-4 hoverable-image"
  //         />
  //       ),
  //       activeIcon: (
  //         <img src={AtriIcon} alt="atributes" className="h-6 w-10 mt-4 mb-4" />
  //       ),
  //       text: "Group Management",
  //       link: "/store-settings/store-groups",
  //       // link: "/store-settings/create-group",
  //       className: "Create-Store-for-android",
  //     };
  //     const updateItems = menuItems?.map((item) => {
  //       if (item.id === 10 && item.dropdownItems) {
  //         return {
  //           ...item,
  //           dropdownItems: [
  //             ...item.dropdownItems,
  //             newCreateGroup,
  //             // newregistersetting,
  //             // newMenuItemDigit,
  //           ],
  //         };
  //       }
  //       return item;
  //     });
  //     console.log("updateItems===>", updateItems, LoginGetDashBoardRecordJson);
  //     // let updatedMenuItems = [...updateItems];
  //     setMenuItemSwitcher(updateItems);
  //   }
  // }, [LoginGetDashBoardRecordJson?.data?.zoho_enable]);

  // useEffect(() => {
  //   if (LoginGetDashBoardRecordJson?.login_type === "merchant") {
  //     const newCreateGroup = {
  //       id: 70,
  //       icon: (
  //         <img
  //           src={AttributesIcon}
  //           alt="create-group"
  //           className="h-6 w-10 mt-4 mb-4 hoverable-image"
  //         />
  //       ),
  //       activeIcon: (
  //         <img src={AtriIcon} alt="atributes" className="h-6 w-10 mt-4 mb-4" />
  //       ),
  //       text: "Create Group",
  //       link: "/store-settings/store-groups",
  //       // link: "/store-settings/create-group",
  //       className: "Create-Store-for-android",
  //     };
  //     const updateItems = menuItems?.map((item) => {
  //       if (item.id === 10 && item.dropdownItems) {
  //         return {
  //           ...item,
  //           dropdownItems: [
  //             ...item.dropdownItems,
  //             newCreateGroup,
  //             // newregistersetting,
  //             // newMenuItemDigit,
  //           ],
  //         };
  //       }
  //       return item;
  //     });
  //     console.log("updateItems===>", updateItems, LoginGetDashBoardRecordJson);
  //     // let updatedMenuItems = [...updateItems];
  //     setMenuItemSwitcher([...updateItems]);
  //   }
  // }, [LoginGetDashBoardRecordJson?.login_type]);

  useEffect(() => {
    if (LoginGetDashBoardRecordJson?.login_type === "superadmin") {
      setMenuItemSwitcher((menuItems) => [...menuItems]);
    }
    if (!!LoginGetDashBoardRecordJson?.login_type) {
    } else {
      Cookies.remove('loginDetails');
      Cookies.remove('superadmin_details');
      try {
        localStorage.removeItem("permissionPresetData");
      } catch (e) { }
      navigate('/login');
    }
  }, [LoginGetDashBoardRecordJson?.login_type]);

  function getFirstTwoSegmentsPathIsStoreAvtive(pathname) {
    // console.log("getFirstTwoSegmentsPath",pathname)
    const segments = pathname?.split("/").filter(Boolean) || [];
    return isStoreActive
      ? "/" + segments.slice(0, 1).join("/")
      : "/" + segments.slice(0, 2).join("/");
  }

  // One restore for the whole menu — not N DropdownMenuItem effects.
  // Also runs on tablet so the active section is ready when the rail pins open.
  useEffect(() => {
    if (!currentMenuItems?.length) return;

    for (const menuItem of currentMenuItems) {
      const children = menuItem?.dropdownItems;
      if (!children?.length) continue;

      const foundChild = children.find(
        (dropdownChild) =>
          getFirstTwoSegmentsPath(dropdownChild?.link) ===
          getFirstTwoSegmentsPath(activeItem),
      );
      const nestedFound = children.find((nestedItem) => {
        if (!nestedItem?.dropDownItems) return false;
        return nestedItem.dropDownItems.some(
          (child) =>
            child.link === activeItem ||
            getFirstTwoSegmentsPath(child.link) ===
            getFirstTwoSegmentsPath(activeItem),
        );
      });

      if (!foundChild && !nestedFound) continue;

      activeDropDownItem(menuItem.id);
      if (nestedFound) {
        setActiveNestedItem(nestedFound.id);
      }
      return;
    }
  }, [activeItem, menuItemSwitcher]);

  // function handleHowerOnIcons(id) {
  //   setHoveredItem(id);
  //   dispatch(setMenuOpen(Boolean(id)));
  // }
  // const [openedByHover, setOpenedByHover] = useState(false);
  function handleHowerOnIcons(_id) {
    // No-op: hover expand is CSS-only. setState here re-rendered the full menu.
  }

  const isTouchScreen = () => {
    return (
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0 ||
      window.matchMedia("(pointer: coarse)").matches
    );
  };

  // Single tree for expanded + collapsed — toggling only flips CSS classes.
  // Desktop hover expand is CSS-only (see SidebarWorkspace.css) so Redux is
  // not involved on mouse enter/leave.
  const renderMenuItems = (items) =>
    items?.map((item) => {
      const isItemActive = item.link
        ? getFirstTwoSegmentsPathIsStoreAvtive(activeItem) ===
        getFirstTwoSegmentsPathIsStoreAvtive(item.link)
        : false;
      const isSectionOpen = currentDropDownItem === item.id;
      let isSectionActive = false;
      if (item.dropdownItems?.length) {
        isSectionActive = item.dropdownItems.some((dropdownChild) => {
          if (
            getFirstTwoSegmentsPath(dropdownChild?.link) ===
            getFirstTwoSegmentsPath(activeItem)
          ) {
            return true;
          }
          return dropdownChild?.dropDownItems?.some(
            (child) =>
              child.link === activeItem ||
              getFirstTwoSegmentsPath(child.link) ===
              getFirstTwoSegmentsPath(activeItem),
          );
        });
      }
      return (
        <div
          key={item.id}
          className={`qv-app-sidebar__item ${activeItem === item.link ? "active" : ""
            }`}
        >
          {item.dropdownItems ? (
            <DropdownMenuItem
              setHoveredItem={setHoveredItem}
              item={item}
              activeItem={isSectionOpen ? activeItem : null}
              setActiveItem={setActiveItem}
              hoveredItem={hoveredItem}
              isSectionOpen={isSectionOpen}
              isSectionActive={isSectionActive}
              activeDropDownItem={activeDropDownItem}
              activeNestedItem={isSectionOpen ? activeNestedItem : null}
              setActiveNestedItem={setActiveNestedItem}
              isTabletNav={isTabletNav}
              hasMenuSectionAccess={hasMenuSectionAccess}
              isStoreActive={isStoreActive}
            />
          ) : (
            <Link
              to={item.link}
              title={item.text}
              aria-label={item.text}
              onClick={(e) => handleItemClick(item, e)}
              style={{ cursor: "pointer", textDecoration: "none" }}
              aria-current={isItemActive ? "page" : undefined}
              className={`qv-app-sidebar__link flex items-center ${item?.className || ""
                } ${isItemActive
                  ? "qv-app-sidebar__link--active bg-[#414F54] text-[#FFC400]"
                  : ""
                }`}
            >
              {/* Inline-SVG icons (e.g. Quickvee HQ) carry their own stroke
                  colours, so the `--active img` filter in SidebarWorkspace.css
                  cannot recolour them — they need the real activeIcon. Items
                  that never defined one fall back to the plain icon. */}
              {isItemActive ? item.activeIcon || item.icon : item.icon}
              <p
                className={`qv-app-sidebar__label ml-2 menu-item text-[14px] Admin_std ${activeItem === item.link?.trim?.() ? "bg-[#414F54]" : ""
                  }`}
              >
                {item.text}
              </p>
            </Link>
          )}
        </div>
      );
    });

  return (
    <SideMenuFrame
      desktopContent={renderMenuItems(currentMenuItems)}
      mobileContent={renderMenuItems(
        LoginGetDashBoardRecordJson?.final_login == 1
          ? temp["superadmin"]
          : temp[LoginGetDashBoardRecordJson?.data?.login_type],
      )}
    />
  );
};

/** Bumps when hover leave finishes so dropdowns can restore after a manual close. */
const SidebarHoverSessionContext = createContext(0);

/**
 * Desktop pin is CSS-only via html[data-qv-sidebar-pinned] (set sync in Header).
 * This shell stays `--collapsed` and does NOT re-render on hamburger pin —
 * that React class swap was the toggle lag.
 */
function SideMenuFrame({ desktopContent, mobileContent }) {
  const store = useStore();
  const isMobileViewActive = useSelector(
    (state) => state.NavBarToggle.isMobileView,
  );
  const isMobileNav = useMediaQuery("(min-width:767px)");
  const shellRef = useRef(null);
  const graceTimerRef = useRef(null);
  const suppressLeaveUntilRef = useRef(0);
  // Locks CSS :hover expand after pointer leaves so the rail does not
  // re-open while crossing the old overlay into page content.
  const [isHoverDismissed, setIsHoverDismissed] = useState(false);
  const isHoverDismissedRef = useRef(false);
  const [hoverSession, setHoverSession] = useState(0);

  const clearGraceTimer = useCallback(() => {
    if (graceTimerRef.current) {
      clearTimeout(graceTimerRef.current);
      graceTimerRef.current = null;
    }
  }, []);

  const clearHoverDismiss = useCallback(() => {
    clearGraceTimer();
    if (!isHoverDismissedRef.current) return;
    isHoverDismissedRef.current = false;
    setIsHoverDismissed(false);
  }, [clearGraceTimer]);

  // Keep attribute in sync + clear hover-dismiss on pin — without useSelector
  // (useSelector re-rendered the shell and swapped --expanded/--collapsed).
  useEffect(() => {
    let prevOpen = store.getState().NavBarToggle.isMenuOpen;
    document.documentElement.setAttribute(
      "data-qv-sidebar-pinned",
      prevOpen ? "1" : "0",
    );

    return store.subscribe(() => {
      const open = store.getState().NavBarToggle.isMenuOpen;
      if (open === prevOpen) return;
      prevOpen = open;
      document.documentElement.setAttribute(
        "data-qv-sidebar-pinned",
        open ? "1" : "0",
      );
      // Only re-render shell if we actually need to clear a dismiss lock.
      if (open) clearHoverDismiss();
    });
  }, [store, clearHoverDismiss]);

  useEffect(() => () => clearGraceTimer(), [clearGraceTimer]);

  const handleDesktopMouseEnter = useCallback(() => {
    clearHoverDismiss();
  }, [clearHoverDismiss]);

  const handleDesktopMouseDown = useCallback(() => {
    suppressLeaveUntilRef.current = Date.now() + 400;
    clearHoverDismiss();
  }, [clearHoverDismiss]);

  const handleDesktopMouseLeave = useCallback(
    (event) => {
      if (store.getState().NavBarToggle.isMenuOpen) return;

      const shell = shellRef.current;
      const related = event?.relatedTarget;
      if (related instanceof Node && shell?.contains(related)) {
        return;
      }

      const dismiss = () => {
        graceTimerRef.current = null;
        if (store.getState().NavBarToggle.isMenuOpen) return;
        // Pointer returned during grace — keep hover expand.
        if (shellRef.current?.matches(":hover")) return;
        isHoverDismissedRef.current = true;
        setIsHoverDismissed(true);
        // New hover session: allow route-matched dropdowns to open again.
        setHoverSession((n) => n + 1);
      };

      const suppressFor = suppressLeaveUntilRef.current - Date.now();
      clearGraceTimer();
      graceTimerRef.current = setTimeout(dismiss, Math.max(suppressFor, 50));
    },
    [store, clearGraceTimer],
  );

  // Desktop always `--collapsed`; pin width/labels come from data-qv-sidebar-pinned.
  const shellClass = `sidebar-menu custom-scroll qv-app-sidebar qv-app-sidebar--collapsed${isHoverDismissed ? " qv-app-sidebar--hover-dismissed" : ""
    }`;
  const shellStyle = {
    paddingTop: "calc(69px + var(--qv-timesheet-top-banner-height, 0px))",
  };

  if (isMobileNav) {
    return (
      <SidebarHoverSessionContext.Provider value={hoverSession}>
        <div
          ref={shellRef}
          className={`${shellClass} qv-app-sidebar--desktop`}
          aria-label="Primary navigation"
          style={shellStyle}
          onMouseEnter={handleDesktopMouseEnter}
          onMouseLeave={handleDesktopMouseLeave}
          onMouseDown={handleDesktopMouseDown}
        >
          <div className="qv-app-sidebar__surface flex-1 bg-[#253338] text-[#9E9E9E]">
            {desktopContent}
          </div>
        </div>
      </SidebarHoverSessionContext.Provider>
    );
  }

  if (isMobileViewActive) {
    return (
      <div
        className="sidebar-menu custom-scroll qv-app-sidebar qv-app-sidebar--expanded qv-app-sidebar--mobile"
        aria-label="Primary navigation"
        style={shellStyle}
      >
        <div className="qv-app-sidebar__surface flex-1 bg-[#253338] text-[#9E9E9E]">
          {mobileContent}
        </div>
      </div>
    );
  }

  return null;
}

const DropdownMenuItem = memo(function DropdownMenuItem({
  item,
  activeItem,
  setActiveItem,
  setHoveredItem,
  hoveredItem,
  isSectionOpen,
  isSectionActive,
  activeDropDownItem,
  activeNestedItem,
  setActiveNestedItem,
  isTabletNav,
  hasMenuSectionAccess,
  isStoreActive,
}) {
  const dispatch = useDispatch();
  const store = useStore();
  const navigate = useNavigate();
  const [dropDownItem, setDropDownItem] = useState(null);
  // Manual close while hover/pin expanded — parent restore must not fight it.
  const [forceClosed, setForceClosed] = useState(false);
  const forceClosedRef = useRef(false);
  const hoverSession = useContext(SidebarHoverSessionContext);

  const getMenuOpen = () => store.getState().NavBarToggle.isMenuOpen;

  const setMenuForceClosed = (closed) => {
    forceClosedRef.current = closed;
    setForceClosed(closed);
  };

  // Clear manual close on new hover session / pin / route into this section.
  useEffect(() => {
    if (!forceClosedRef.current) return;
    setMenuForceClosed(false);
  }, [hoverSession, activeItem]);

  // Sync local active child highlight when this section is open.
  useEffect(() => {
    if (!isSectionOpen || !activeItem) return;
    setDropDownItem(activeItem);
  }, [isSectionOpen, activeItem]);

  const isNewTabIntent = (event) => {
    return (
      !!event &&
      (event.ctrlKey || event.metaKey || event.shiftKey || event.button === 1)
    );
  };

  const isModifiedNavigationEvent = (event) =>
    Boolean(
      event &&
      (event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey ||
        event.button === 1),
    );

  const handleToggleDropdownItems = (nestedItem, e) => {
    // Lottery is always shown but only accessible when the EBT flag === 4
    // (nestedItem.lotteryAccessAllowed); otherwise deny like any other page.
    const closeDropdownSideMenuOnMobile = () => {
      // Only collapse on narrow viewports — keep desktop sidebar open for new-tab links.
      if (!isTabletNav) return;
      dispatch(setIsDropdownOpen(false));
      dispatch(setMenuOpen(false));
      dispatch(setIsMobileViewActive(false));
      setHoveredItem(null);
      activeDropDownItem(null);
    };

    if (
      nestedItem?.lotteryAccessAllowed === false ||
      !canAccessMenuLink(nestedItem.link, isStoreActive)
    ) {
      e?.preventDefault?.();
      ToastifyAlert("Access Denied", "error");
      if (isNewTabIntent(e)) {
        window.open("/merchants" + nestedItem.link, "_blank");
      }
      return;
    }
    if (nestedItem.alwaysNewTab) {
      e?.preventDefault?.();
      window.open("/merchants" + nestedItem.link, "_blank");
      closeDropdownSideMenuOnMobile();
      return;
    }
    if (isNewTabIntent(e)) {
      window.open("/merchants" + nestedItem.link, "_blank");
      closeDropdownSideMenuOnMobile();
      return;
    }
    if (isModifiedNavigationEvent(e)) {
      return;
    }
    e?.preventDefault?.();
    if (isTabletNav) {
      dispatch(setIsDropdownOpen(false));
      dispatch(setMenuOpen(false));
      dispatch(setIsMobileViewActive(false));
      setHoveredItem(null);
      // Keep section id cleared so the next rail-open tap opens (not force-closes).
      activeDropDownItem(null);
    }
    // Desktop: do not touch Redux dropdown/pin — keeps click cheap.
    setDropDownItem(nestedItem.link);
    setActiveNestedItem(null);
    startTransition(() => {
      setActiveItem(nestedItem.link);
    });
    navigate(nestedItem.link, { replace: true });
  };

  /** Tablet/touch has no reliable CSS :hover expand — pin open so labels + submenu show. */
  const openSideMenuIfCollapsed = (e) => {
    if (getMenuOpen()) return;
    e?.stopPropagation?.();
    document.documentElement.setAttribute("data-qv-sidebar-pinned", "1");
    if (isTabletNav) {
      dispatch(pinSidebar({ open: true, isNarrow: true }));
      return;
    }
    dispatch(setMenuOpen(true));
    dispatch(setIsOpenedByIcon(true));
  };

  const isSubmenuVisible = isSectionOpen && !forceClosed;

  return (
    <>
      <div
        className={`qv-app-sidebar__dropdown relative ${item?.className || ""}`}
      >
        <div className="qv-app-sidebar__dropdown-trigger-wrap flex">
          <div
            className={`qv-app-sidebar__trigger w-full flex items-center cursor-pointer ${isSectionActive
              ? "qv-app-sidebar__trigger--active bg-[#414F54]"
              : ""
              }`}
            title={item.text}
            aria-label={item.text}
            aria-expanded={isSubmenuVisible}
            onClick={(e) => {
              e.stopPropagation();
              if (hasMenuSectionAccess && !hasMenuSectionAccess(item?.text)) {
                ToastifyAlert("Access Denied", "error");
                return;
              }

              // Opening from collapsed rail: always expand + show this section.
              // (If section id was still set from last visit, toggle would force-close.)
              const wasCollapsed = !getMenuOpen();
              if (wasCollapsed && (isTabletNav || !HOVER_EXPANDS_RAIL)) {
                openSideMenuIfCollapsed(e);
                setMenuForceClosed(false);
                activeDropDownItem(item.id);
                return;
              }

              // Mobile/tablet drawer: force-closed CSS is desktop-only
              // (`.qv-app-sidebar--desktop`), so accordion must clear the
              // open section id — otherwise the submenu never actually hides.
              if (isTabletNav) {
                if (isSectionOpen) {
                  activeDropDownItem(null);
                  setMenuForceClosed(false);
                  return;
                }
                setMenuForceClosed(false);
                activeDropDownItem(item.id);
                return;
              }

              if (isSubmenuVisible) {
                setMenuForceClosed(true);
                return;
              }

              setMenuForceClosed(false);
              // Local open only — no Redux isDropdownOpen (that re-rendered all items).
              activeDropDownItem(item.id);
            }}
          >
            {item.icon}
            <p
              className={`qv-app-sidebar__label qv-app-sidebar__dropdown-label ml-2 menu-item DropDown-memu text-[14px] flex-auto Admin_std ${isSectionActive ? "activeTab" : ""
                }`}
            >
              {item.text}
            </p>
            <FaChevronDown
              className={`qv-app-sidebar__chevron quickarrow_icon ml-4 me-5${isSubmenuVisible ? " qv-app-sidebar__chevron--open" : ""
                }`}
            />
          </div>
        </div>
      </div>

      {isSectionOpen && (
        <div
          className={`qv-app-sidebar__submenu mt-0 bg-[#334247] shadow w-full text-center z-10${forceClosed ? " qv-app-sidebar__submenu--force-closed" : ""
            }`}
        >
          {item?.dropdownItems?.map((nestedDropdownItem) => (
            <div
              onClick={(e) => {
                e.stopPropagation();
              }}
              key={nestedDropdownItem.id}
              className="qv-app-sidebar__submenu-row"
            >
              {nestedDropdownItem?.dropDownItems ? (
                <NestedDropdownMenu
                  item={nestedDropdownItem}
                  isMenuOpenRedux
                  activeItem={activeItem}
                  dropDownItem={dropDownItem}
                  hoveredItem={hoveredItem}
                  handleToggleDropdownItems={handleToggleDropdownItems}
                  setHoveredItem={setHoveredItem}
                  activeNestedItem={activeNestedItem}
                  setActiveNestedItem={setActiveNestedItem}
                  setDropDownItem={setDropDownItem}
                  activeDropDownItem={activeDropDownItem}
                  isTabletNav={isTabletNav}
                />
              ) : (
                <Link
                  to={nestedDropdownItem.link}
                  aria-current={
                    getFirstTwoSegmentsPath(activeItem) ===
                      getFirstTwoSegmentsPath(nestedDropdownItem.link)
                      ? "page"
                      : undefined
                  }
                  title={nestedDropdownItem.text}
                  className={`qv-app-sidebar__submenu-link flex text-center submenu-item text-gray-400 p-4 text-[14px] ${getFirstTwoSegmentsPath(activeItem) ===
                    getFirstTwoSegmentsPath(nestedDropdownItem.link)
                    ? "qv-app-sidebar__submenu-link--active active"
                    : ""
                    } ${nestedDropdownItem?.submenuIcon ? "qv-app-sidebar__submenu-link--with-icon" : ""} ${nestedDropdownItem?.className || ""} cursor-pointer`}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (
                      !canAccessMenuLink(
                        nestedDropdownItem.link,
                        isStoreActive,
                      )
                    ) {
                      e.preventDefault();
                      ToastifyAlert("Access Denied", "error");
                      return;
                    }
                    if (isNewTabIntent(e)) {
                      return;
                    }
                    handleToggleDropdownItems(nestedDropdownItem, e);
                  }}
                >
                  {nestedDropdownItem.submenuIcon && (
                    <span className="qv-app-sidebar__submenu-icon" aria-hidden="true">
                      {nestedDropdownItem.submenuIcon}
                    </span>
                  )}
                  {nestedDropdownItem.text}
                </Link>
              )}
            </div>
          ))}
        </div>
      )}
    </>
  );
});

// Define menu items with icons and text
// {LoginAllStore?.data?.login_type !== ("admin" && "manager" && "merchant")





const SuperAdminMenuItems = [
  // {
  //   id: 1,
  //   icon: (
  //     <img
  //       src={LabelIcon}
  //       alt="labal"
  //       className="h-6 w-10 mt-4 mb-4 hoverable-image"
  //     />
  //   ),
  //   activeIcon: (
  //     <img src={LabelActive} alt="Label" className="h-6 w-10 mt-4 mb-4" />
  //   ),
  //   text: "Label",
  //   link: "/users/view/unapprove/label",
  // },
  {
    id: 2,
    icon: (
      <img
        src={UsersICcon}
        alt="store"
        className="h-6 w-10 mt-4 mb-4 hoverable-image"
      />
    ),
    activeIcon: (
      <img src={UserActive} alt="active store" className="h-6 w-10 mt-4 mb-4" />
    ),
    text: "Users",
    link: "/users/view/unapprove/users/add",
    className: "Users-for-android",
    dropdownItems: [
      {
        id: 21,
        text: "Merchants",
        link: "/users/merchant",
        className: "Add-for-android",
      },
      {
        id: 22,
        text: "Live Stores",
        link: "/users/approve",
        className: "Verified-Merchant-for-android",
      },
      {
        id: 23,
        icon: (
          <img src={CouponIcon} alt="option" className="h-6 w-10 mt-4 mb-4" />
        ),
        activeIcon: (
          <img src={CouIcon} alt="option" className="h-6 w-10 mt-4 mb-4 " />
        ),
        text: "Inactive Stores",
        link: "/users/unapprove",
        className: "Unverified-Merchant-for-android",
      },

      // {
      //   id: 26,
      //   text: "Customers",
      //   link: "/users/customer",
      //   className: "Customer-for-android",
      // },
      // {
      //   id: 27,
      //   text: "Admin",
      //   link: "/users/admin",
      //   className: "Admin-for-android",
      // },
      // {
      //   id: 28,
      //   text: "Manager",
      //   link: "/users/manager_view",
      //   className: "Manager-for-android",
      // },
      {
        id: 1761296022,
        text: "Superadmin List",
        link: "/users/superadmin_list",
        className: "Superadmin-list-for-android",
      },
    ],
  },

  // {
  //   id: 3,
  //   icon: (
  //     <img
  //       src={NewsletterIcon}
  //       alt="labal"
  //       className="h-6 w-10 mt-4 mb-4 hoverable-image"
  //     />
  //   ),
  //   activeIcon: (
  //     <img
  //       src={NewsletterActive}
  //       alt="Newsletter"
  //       className="h-6 w-10 mt-4 mb-4"
  //     />
  //   ),
  //   text: "Newsletter",
  //   link: "/users/view/unapprove/newsletter",
  // },
  // {
  //   id: 4,
  //   icon: (
  //     <img
  //       src={StoreIcon}
  //       alt="Store Order"
  //       className="h-6 w-10 mt-4 mb-4 hoverable-image"
  //     />
  //   ),
  //   activeIcon: (
  //     <img
  //       src={StoreActive}
  //       alt="Store Order "
  //       className="h-6 w-10 mt-4 mb-4"
  //     />
  //   ),
  //   text: "Store Order",
  //   link: "/unapprove/store-order",
  //   className: "Store-Order-for-android",
  // },
  {
    id: 6,
    icon: (
      <img
        src={StoreSettingIcon}
        alt="store"
        className="h-6 w-10 mt-4 mb-4 hoverable-image"
      />
    ),
    activeIcon: (
      <img
        src={SettingIcon}
        alt="active store"
        className="h-6 w-10 mt-4 mb-4"
      />
    ),
    text: "Store Settings",
    link: "/store-settings/info",
    className: "Store-Settings-for-android",
    dropdownItems: [
      {
        id: 6,
        icon: (
          <img
            src={DefaultIcon}
            alt="labal"
            className="h-6 w-10 mt-4 mb-4 hoverable-image"
          />
        ),
        activeIcon: (
          <img
            src={DefaultActive}
            alt="menu-defaults"
            className="h-6 w-10 mt-4 mb-4"
          />
        ),
        text: "Default Category",
        // link: "/users/view/unapprove/menu/defaults",
        link: "/unapprove/defaults",
        className: "Defaults-for-android",
      },
      {
        id: 45,
        icon: (
          <img
            src={DefaultIcon}
            alt="labal"
            className="h-6 w-10 mt-4 mb-4 hoverable-image"
          />
        ),
        activeIcon: (
          <img
            src={DefaultActive}
            alt="menu-add-banner"
            className="h-6 w-10 mt-4 mb-4"
          />
        ),
        text: "Feature Store",
        link: "/unapprove/banners",
        className: "Defaults-for-android",
      },
      {
        id: 17224906912,
        text: "Configure Categories",
        link: "/unapprove/Configure_Categories",
        className: "Newsletter-Subscribe-for-android",
      },
      {
        id: 17224906913,
        text: "Restricted Keywords",
        link: "/unapprove/restricted-keywords",
        className: "Restricted-Keywords-for-android",
      },
      {
        id: 1751445995098,
        text: "Quickvee Custom",
        link: "/unapprove/Quickvee-Custom",
        className: "Quickvee-Custom-for-android",
      },
      {
        id: 1713700000000,
        text: "Feature Announcements",
        link: "/unapprove/Feature-Announcements",
        className: "Feature-Announcements-for-android",
      },
    ],
  },
  {
    id: 188812345,
    icon: (
      <img
        src={SMSIcon}
        alt="Bulk SMS System"
        className="h-6 w-10 mt-4 mb-4 hoverable-image"
      />
    ),
    activeIcon: (
      <img
        src={SMSIconY}
        alt="Bulk SMS System"
        className="h-6 w-10 mt-4 mb-4"
      />
    ),
    text: "Bulk SMS System",
    link: "/unapprove/bulk-sms-system",
    className: "Telnyx-Mass-SMS-System-for-android",
  },

  // {
  //   id: 6,
  //   icon: (
  //     <img
  //       src={DefaultIcon}
  //       alt="labal"
  //       className="h-6 w-10 mt-4 mb-4 hoverable-image"
  //     />
  //   ),
  //   activeIcon: (
  //     <img
  //       src={DefaultActive}
  //       alt="menu-defaults"
  //       className="h-6 w-10 mt-4 mb-4"
  //     />
  //   ),
  //   text: "Defaults",
  //   // link: "/users/view/unapprove/menu/defaults",
  //   link: "/unapprove/defaults",
  //   className: "Defaults-for-android",
  // },
  // {
  //   id: 45,
  //   icon: (
  //     <img
  //       src={DefaultIcon}
  //       alt="labal"
  //       className="h-6 w-10 mt-4 mb-4 hoverable-image"
  //     />
  //   ),
  //   activeIcon: (
  //     <img
  //       src={DefaultActive}
  //       alt="menu-add-banner"
  //       className="h-6 w-10 mt-4 mb-4"
  //     />
  //   ),
  //   text: "Banners",
  //   link: "/unapprove/banners",
  //   className: "Defaults-for-android",
  // },

  // {
  //   id: 7,
  //   icon: (
  //     <img
  //       src={ApkIcon}
  //       alt="release_apk"
  //       className="h-6 w-10 mt-4 mb-4 hoverable-image"
  //     />
  //   ),
  //   activeIcon: (
  //     <img src={ApkActive} alt="release_apk" className="h-6 w-10 mt-4 mb-4" />
  //   ),
  //   text: "Release APK   ",
  //   link: "/users/view/unapprove/release_apk",
  // },
  {
    id: 10,
    icon: (
      <img
        src={DuplicatesIcon}
        alt="duplicates"
        className="h-6 w-10 mt-4 mb-4 hoverable-image"
      />
    ),
    activeIcon: (
      <img
        src={DuplicatesActive}
        alt="menu-defaults"
        className="h-6 w-10 mt-4 mb-4"
      />
    ),
    text: "Duplicates",
    link: "/unapprove/inverntory-duplicate",
    className: "Duplicates-for-android",
    dropdownItems: [
      {
        id: 8,
        text: "Inventory Duplicate",
        link: "/unapprove/inverntory-duplicate",
        className: "Inventory-Duplicate-for-android",
      },
      {
        id: 9,
        text: "Category Duplicate",
        link: "/unapprove/category-duplicate",
        className: "Category-Duplicate-for-android",
      },
      {
        id: 10,
        text: "Product Duplicate",
        link: "/unapprove/product-duplicate",
        className: "Product-Duplicate-for-android",
      },
    ],
  },

  {
    id: 11,
    icon: (
      <img
        src={PermissionIcon}
        alt="labal"
        className="h-6 w-10 mt-4 mb-4 hoverable-image"
      />
    ),
    activeIcon: (
      <img
        src={PermissionActive}
        alt="menu-defaults"
        className="h-6 w-10 mt-4 mb-4"
      />
    ),
    text: "Permission",
    link: "/unapprove/create_permission",
    className: "Permission-for-android",
    dropdownItems: [
      {
        id: 21,
        text: "Main Permission",
        link: "/unapprove/create_main_permission",
        className: "Main-Permission-for-android",
      },
      {
        id: 22,
        text: "Sub Permission",
        link: "/unapprove/create_permission",
        className: "Sub-Permission-for-android",
      },
    ],
  },

  {
    id: 1745900003000,
    icon: (
      <img
        src={MerchantsExportY}
        alt="Merchants Export"
        className="h-6 w-10 mt-4 mb-4 hoverable-image"
      />
    ),
    activeIcon: (
      <img
        src={MerchantsExport}
        alt="Merchants Export"
        className="h-6 w-10 mt-4 mb-4"
      />
    ),
    text: "Merchants Export",
    link: "/unapprove/merchants-export",
    className: "Merchants-Export-for-android",
    dropdownItems: [
      {
        id: 118,
        text: "Customer Export",
        link: "/unapprove/customer-export",
        className: "Customer-Export-for-android",
      },
      {
        id: 119,
        text: "Order Wise Export",
        link: "/unapprove/order-wise-export",
        className: "Order-Wise-Export-for-android",
      },
      {
        id: 120,
        text: "Item Wise Export",
        link: "/unapprove/item-wise-export",
        className: "Item-Wise-Export-for-android",
      },
      {
        id: 121,
        text: "Product Profitability",
        link: "/unapprove/product-profitability-export",
        className: "Product-Profitability-Export-for-android",
      },
      {
        id: 119,
        text: "Tip Report Export",
        link: "/unapprove/tip-report-export",
        className: "Tip-Report-Export-for-android",
      },
      {
        id: 123,
        text: "Purchase Order Report Export",
        link: "/unapprove/purchase-order-report-export",
        className: "Purchase-Order-Report-Export-for-android",
      },
      {
        id: 122,
        text: "Sales by Category Per Employee",
        link: "/unapprove/sales-by-category-per-employee-export",
        className: "Sales-By-Category-Per-Employee-Export-for-android",
      },
      {
        id: 123,
        text: "Sales by Tender Export",
        link: "/unapprove/sales-by-tender-export",
        className: "Sales-By-Tender-Export-for-android",
      },
    ],
  },

  {
    id: 12,
    icon: (
      <img
        src={Support1}
        alt="labal"
        className="h-6 w-10 mt-4 mb-4 hoverable-image"
      />
    ),
    activeIcon: (
      <img src={Support} alt="menu-defaults" className="h-6 w-10 mt-4 mb-4" />
    ),
    text: "Support Details",
    link: "/unapprove/support-details",
    className: "Support-Details-for-android",
  },

  // {
  //   id: 13,
  //   icon: (
  //     <img
  //       src={MerchantIcon}
  //       alt="labal"
  //       className="h-6 w-10 mt-4 mb-4 hoverable-image"
  //     />
  //   ),
  //   activeIcon: (
  //     <img
  //       src={MerchantActive}
  //       alt="menu-defaults"
  //       className="h-6 w-10 mt-4 mb-4"
  //     />
  //   ),
  //   text: "Merchant Details ",
  //   link: "/users/view/unapprove/merchant-details",
  // },
  // {
  //   id: 12,
  //   icon: (
  //     <img
  //       src={MerchantIcon}
  //       alt="labal"
  //       className="h-6 w-10 mt-4 mb-4 hoverable-image"
  //     />
  //   ),
  //   activeIcon: (
  //     <img
  //       src={MerchantActive}
  //       alt="menu-defaults"
  //       className="h-6 w-10 mt-4 mb-4"
  //     />
  //   ),
  //   text: "Need Help ",
  //   link: "/users/view/unapprove/need-help",
  // },

  {
    id: 20240701,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#8a9ba8"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="h-6 w-6 shrink-0 hoverable-image"
        style={{ width: "24px", height: "24px" }}
      >
        <path d="M21 2v6h-6" />
        <path d="M3 12a9 9 0 0 1 15-6.7L21 8" />
        <path d="M3 22v-6h6" />
        <path d="M21 12a9 9 0 0 1-15 6.7L3 16" />
      </svg>
    ),
    activeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#EFAF1C"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="h-6 w-6 shrink-0"
        style={{ width: "24px", height: "24px" }}
      >
        <path d="M21 2v6h-6" />
        <path d="M3 12a9 9 0 0 1 15-6.7L21 8" />
        <path d="M3 22v-6h6" />
        <path d="M21 12a9 9 0 0 1-15 6.7L3 16" />
      </svg>
    ),
    text: "Product Sync",
    link: "/unapprove/product-sync",
    className: "Product-Sync-for-android",
  },
  {
    id: 20240702,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#8a9ba8"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="h-6 w-6 shrink-0 hoverable-image"
        style={{ width: "24px", height: "24px" }}
      >
        <path d="M3 3v18h18" />
        <path d="M7 15l4-4 3 3 5-6" />
        <path d="M19 8h-3" />
        <path d="M19 8v3" />
      </svg>
    ),
    activeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#EFAF1C"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="h-6 w-6 shrink-0"
        style={{ width: "24px", height: "24px" }}
      >
        <path d="M3 3v18h18" />
        <path d="M7 15l4-4 3 3 5-6" />
        <path d="M19 8h-3" />
        <path d="M19 8v3" />
      </svg>
    ),
    text: "Report Sync",
    link: "/unapprove/report-sync",
    className: "Report-Sync-for-android",
  },
  {
    // Superadmin > Owner Report: which merchants see it, and who can sign in.
    id: 20261028,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#8a9ba8"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="h-6 w-6 shrink-0 hoverable-image"
        style={{ width: "24px", height: "24px" }}
      >
        <path d="M13 2L4.5 13.5H11L10 22l8.5-11.5H12L13 2z" />
      </svg>
    ),
    activeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#EFAF1C"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="h-6 w-6 shrink-0"
        style={{ width: "24px", height: "24px" }}
      >
        <path d="M13 2L4.5 13.5H11L10 22l8.5-11.5H12L13 2z" />
      </svg>
    ),
    text: "Owner Report",
    link: "/unapprove/owner-report",
    className: "Owner-Report-Admin-for-android hidden",
  },
  {
    id: 111,
    icon: (
      <img
        src={PermissionIcon}
        alt="labal"
        className="h-6 w-10 mt-4 mb-4 hoverable-image"
      />
    ),
    activeIcon: (
      <img
        src={PermissionActive}
        alt="menu-defaults"
        className="h-6 w-10 mt-4 mb-4"
      />
    ),
    text: "Support",
    link: "/unapprove/support-details",
    className: "Support-for-android",
    dropdownItems: [
      {
        id: 112,
        text: "All Inventory Update",
        link: "/unapprove/all-inventory-update",
        className: "All-Inventory-Update-for-android",
      },
      {
        id: 113,
        text: "Order Retrieve",
        link: "/unapprove/order-retrieve",
        className: "Order-Retrieve-for-android",
      },
      {
        id: 114,
        text: "Newsletter Subscribers",
        link: "/unapprove/newsletter-subscribed",
        className: "Newsletter-Subscribe-for-android",
      },
      {
        id: 115,
        text: "Inventory Export",
        link: "/unapprove/invertory-export",
        className: "Inventory-Export-for-android",
      },
      {
        id: 116,
        text: "Refund Request",
        link: "/unapprove/refund-request",
        className: "Refund-Request-for-android",
      },
      {
        id: 117,
        text: "Order Count",
        link: "/unapprove/order-count",
        className: "Order-Count-for-android",
      },
    ],
  },
  {
    id: 20261023,
    icon: (
      <img
        src={AttributesIcon}
        alt="Audit Log"
        className="h-6 w-10 mt-4 mb-4 hoverable-image"
      />
    ),
    activeIcon: (
      <img src={AtriIcon} alt="Audit Log" className="h-6 w-10 mt-4 mb-4" />
    ),
    text: "Audit Log",
    link: "/unapprove/audit-log",
    className: "Superadmin-Audit-Log-for-android",
  },
];

const merchant = [
  {
    id: 1732611279072,
    text: "Store",
    link: "/store",
    className: "Store-for-android",
    icon: (
      <img
        src={storeIcon}
        alt="labal"
        className="h-6 w-10 mt-4 mb-4 hoverable-image"
      />
    ),
    activeIcon: (
      <img
        src={storeIconActive}
        alt="menu-defaults"
        className="h-6 w-10 mt-4 mb-4"
      />
    ),
  },
  {
    id: 1732611289107,
    text: "Manager ",
    link: "/manager",
    className: "Manager-for-android",
    icon: (
      <img
        src={ManagerIcon}
        alt="labal"
        className="h-6 w-10 mt-4 mb-4 hoverable-image"
      />
    ),
    activeIcon: (
      <img
        src={ManagerIconActive}
        alt="menu-defaults"
        className="h-6 w-10 mt-4 mb-4"
      />
    ),
  },
];

const ManagerLink = [
  {
    // id: 82,
    text: "Store",
    link: "/store",
    className: "Store-for-android",
  },
];

const MerchantLink = [
  {
    // id: 82,
    text: "Store",
    link: "/store",
    className: "Store-for-android",
    icon: (
      <img
        src={storeIcon}
        alt="labal"
        className="h-6 w-10 mt-4 mb-4 hoverable-image"
      />
    ),
    activeIcon: (
      <img
        src={storeIconActive}
        alt="menu-defaults"
        className="h-6 w-10 mt-4 mb-4"
      />
    ),
  },
];
// }MerchantLink

export default SideMenu;
